/* eslint-disable no-useless-return */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  IconButton,
  Typography,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  Slider,
  Stack,
  TextField,
  DialogContent,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Switch,
  Badge,
  Grid,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogContentText,
  Paper
} from '@mui/material';

import store from 'store2';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BrushIcon from '@mui/icons-material/Brush';
import CancelIcon from '@mui/icons-material/Cancel';
import UpdateIcon from '@mui/icons-material/Update';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import Forward10Icon from '@mui/icons-material/Forward10';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import Replay10Icon from '@mui/icons-material/Replay10';
import { v4 as generateUUID } from 'uuid';
import chalk from 'chalk';
import Fade from '@mui/material/Fade';
import { useSelector, useDispatch } from 'react-redux';
import { forEach } from 'lodash';
import VolumeUp from '@mui/icons-material/VolumeUp';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import CloseIcon from '@mui/icons-material/Close';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import TimeRange from 'react-video-timelines-slider';
import { format, subSeconds } from 'date-fns';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Marquee from 'react-fast-marquee';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import screenfull from 'screenfull';
import { findDOMNode } from 'react-dom';
import GroupIcon from '@mui/icons-material/Group';
import WidgetsIcon from '@mui/icons-material/Widgets';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import SensorAltIcon from '@mui/icons-material/CameraAlt';
import DateRangeIcon from '@mui/icons-material/DateRange';
import moment from 'moment';
import ReplayIcon from '@mui/icons-material/Replay';
import { DatePicker } from 'antd';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SyncIcon from '@mui/icons-material/Sync';
import { styled } from '@mui/material/styles';
import LineWidthPicker from '../line-width-picker/lineWidthPicker';
import MultiSelector from '../multi-selector/multiSelector';
import Iconify from '../iconify';
import axiosInstance from '../../utils/axiosInstance';
import { appSliceActions } from '../../appSlices/appSlice';
import getTimelineGaps from '../../utils/getTimelineGaps';
import useResponsive from '../../hooks/useResponsive';
import './videoPlayer.css';
import SensorInfoDrawer from '../sensor-info-drawer/sensorInfoDrawer';

const PEER_CONNECTION_OPTIONS = { optional: [{ DtlsSrtpKeyAgreement: true }] };
const OFFER_OPTIONS = { offerToReceiveAudio: true, offerToReceiveVideo: true };
let isStopping = false;

export const VIDEO_STATUS = Object.freeze({
  UNINITIALIZED: 'UNINITIALIZED',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  ERROR: 'ERROR',
});

export const PLAYBACK_TYPE = Object.freeze({
  UNINITIALIZED: 'UNINITIALIZED',
  LIVE: 'LIVE',
  RECORDED: 'RECORDED',
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const toolTipHelperTextForTripwire = `Place four points follow by an arrow to draw Tripwire`;
const toolTipHelperTextForRoi = `Place any number of points and click on first point to draw the ROI`;
const toolTipHelperShowRoiTripwire = `Show the selected ROIs and Tripwires in the video player`;
const toolTipHelperDeleteRoiTripwire = `Delete the selected ROIs and Tripwires`;
const analyticsRefreshHelperText = `Sync ROI and Tripwire data`;
const analyticsSettingsHelperText = `Analytics settings`;

export default function VideoPlayer({
  sensor,
  sensorInRow,
  isStreamer,
  page,
  onlyVideo,
  closeSensor,
  recordingTest,
  liveTest,
  useVideoCoordinates,
  videoWallList,
}) {
  const [iceConnectionState, setIceConnectionState] = useState();
  const [mediaStream, setMediaStream] = useState();
  const [peerIdStateVariable, setPeerIdStateVariable] = useState('');
  const isDesktop = useResponsive('up', 'lg');
  const [playerSate, setPlayerState] = useState(VIDEO_STATUS.UNINITIALIZED);
  const [loading, setLoading] = useState(false);
  const [sensorStreamList, setSensorStreamList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [sensorClientList, setSensorClientList] = useState([]);
  const [isAudioTrackPresent, setIsAudioTrackPresent] = useState(false);
  const [subStreamAnchorEl, setSubStreamAnchorEl] = useState(null);
  const [clientAnchorEl, setClientAnchorEl] = useState(null);
  const [qualityAnchorEl, setQualityAnchorEl] = useState(null);
  const [recordingStatus, setRecordingStatus] = useState(false);
  const [timelines, setTimelines] = useState([]);
  const [timelineScrubberError, setTimelineScrubberError] = useState(false);
  const [selectedInterval, setSelectedInterval] = useState([]);
  const [showOverlaySettings, setShowOverlaySettings] = useState(false);
  const selectedIntervalRef = useRef([]);
  const [timelineGaps, setTimelineGaps] = useState([]);
  const [volumeLevel, setVolumeLevel] = useState(0);
  const [selectedSubStreamId, setSelectedSubStreamId] = useState(sensor.sensorId);
  const subStreamIdRef = useRef(sensor.sensorId);
  const [quality, setQuality] = useState('auto');
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [videoControlsVisible, setVideoControlsVisible] = useState(false);
  const [overlayDebug, setOverlayDebug] = useState(false);
  const [overlayBbox, setOverlayBbox] = useState(false);
  const [overlayTripwire, setOverlayTripwire] = useState(false);
  const [overlayRoi, setOverlayRoi] = useState(false);
  const [overlayFilter, setOverlayFilter] = useState([]);
  const [endTimeInMsNeeded, setEndTimeInMsNeeded] = useState(false);
  const [endTimeDateNeeded, setEndTimeDateNeeded] = useState(false);
  const [overlayColor, setOverlayColor] = useState('red');
  const [bboxThickness, setBboxThickness] = useState(6);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [streamStatus, setStreamStatus] = useState('');
  const peerConnection = useRef();
  const getIceCandidateCount = useRef(0);
  const videoRef = useRef();
  const peerId = useRef();
  const mediaSessionId = useRef();
  const firstTimeRender = useRef(false);
  const errorTimeoutRef = useRef();
  const earlyCandidates = useRef([]);
  const candidateSet = useRef(new Set());
  const pollRef = useRef();
  const lastSeekRef = useRef();
  const webrtcStatsRef = useRef();
  const frameErrorRef = useRef(0);
  const originalTimelines = useRef();
  const streamSettings = useRef();

  const hhStartRef = useRef('');
  const mmStartRef = useRef('');
  const ssStartRef = useRef('');
  const hhEndRef = useRef('');
  const mmEndRef = useRef('');
  const ssEndRef = useRef('');
  const timelineIntervalRef = useRef('');
  const [openNvStreamerRangeDialog, setOpenNvStreamerRangeDialog] = useState(false);
  const [openMmsRangeDialog, setOpenMmsRangeDialog] = useState(false);
  const [openSyncTimeDialog, setOpenSyncTimeDialog] = useState(false);
  const [playbackType, setPlaybackType] = useState(page === 'recorded' ? 'recorded' : 'live');
  const playbackTypeRef = useRef(page === 'recorded' ? 'recorded' : 'live');
  const [metaData, setMetaData] = useState(null);
  const playNvStreamerRange = useRef(false);
  const nvStreamerRangeStartTime = useRef(null);
  const nvStreamerRangeEndTime = useRef(null);
  const [startDate, setStartDate] = useState(new Date());
  const [startTimeString, setStartTimeString] = useState(startDate);
  const [endDate, setEndDate] = useState(new Date());
  const playMmsRange = useRef(false);
  const mmsRangeStartTime = useRef(null);
  const mmsRangeEndTime = useRef(null);
  const syncTimeRef = useRef(null);
  const recordedStreamTest = useRef(null);
  const statsRef = useRef();
  const fpsTracker = useRef();
  const streamStatusRef = useRef();
  const fpsInterval = useRef();
  const recordingIntervalRef = useRef();
  const dispatch = useDispatch();
  const [recordedTestOperation, setRecordedTestOperation] = useState('...');
  const streamList = useSelector((state) => state.app.streamList);
  const publicIpAddr = useSelector((state) => state.app.publicIp);
  const { adaptorType } = window;
  const operations = useRef(['seek+10', 'seek-10', '1x', '2x', '4x', '8x', '-1x', '-2x', '-4x', '-8x']);

  const overlayRef = useRef(null);

  const [roiOrTripwireCoordinates, setRoiOrTripwireCoordinates] = useState([]);
  const [arrowCoordinates, setArrowCoordinates] = useState([]);

  const [enableRoiDrawing, setEnableRoiDrawing] = useState(false);
  const [enableTripwireDrawing, setEnableTripwireDrawing] = useState(false);

  const [expandGems, setExpandGems] = useState(false);
  const [enableArrowDrawing, setEnableArrowDrawing] = useState(false);

  const [roiName, setRoiName] = useState("");
  const [tripwireName, setTripwireName] = useState("");

  const [openAnalyticsPopup, setOpenAnalyticsPopup] = useState(false);

  // TODO: remove width height state
  const [videoWidth, setVideoWidth] = useState(window.videoWidth || 1920); // debug feature to set width in console
  const [videoHeight, setVideoHeight] = useState(window.videoHeight || 1080); // debug feature to set height in console
  const videoWidthRef = useRef(1920);
  const videoHeightRef = useRef(1080);
  const [videoFramerate, setVideoFramerate] = useState();

  const [isRoiLoopCompleted, setIsRoiLoopCompleted] = useState(false);

  const [roiInputValue, setRoiInputValue] = useState('');
  const [tripwireInputValue, setTripwireInputValue] = useState('');

  const isAnalyticsSettings = useRef(false);
  const [isAnalyticsSettingsState, setIsAnalyticsSettingsState] = useState(false);
  const emdatEndpoint = useRef();
  const [showAnalyticsUI, setShowAnalyticsUI] = useState(false);

  const [roiData, setRoiData] = useState([]);
  const [tripwireData, setTripwireData] = useState([]);

  const [selectedRoiData, setSelectedRoiData] = useState([]);
  const [selectedTripwireData, setSelectedTripwireData] = useState([]);

  const [overlayOpacity, setOverlayOpacity] = useState(255);
  const [isHoveredRoi, setIsHoveredRoi] = useState(false);
  const [isHoveredTripWire, setIsHoveredTripWire] = useState(false);
  const [tooltipTextForRoi, setTooltipTextForRoi] = useState(toolTipHelperTextForRoi);
  const [tooltipTextForTripWire, setTooltipTextForTripWire] = useState(toolTipHelperTextForTripwire);

  useEffect(() => {
    const handleResize = () => {
      handleVideoMetadata();
      setRoiOrTripwireCoordinates([]);
      setArrowCoordinates([]);
      setIsRoiLoopCompleted(false);
      setEnableArrowDrawing(false);
      setEnableTripwireDrawing(false);
      setEnableRoiDrawing(false);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const overlay = overlayRef.current;
    const handleClick = (e) => {
      if ((enableArrowDrawing || enableRoiDrawing || enableTripwireDrawing) && !isRoiLoopCompleted) {
        const rect = overlay.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        if (!enableArrowDrawing) {
          if (roiOrTripwireCoordinates.length > 0) {
            const firstCoordinate = roiOrTripwireCoordinates[0];
            const distance = Math.sqrt((x - firstCoordinate.x) ** 2 + (y - firstCoordinate.y) ** 2);
            if (distance < 10 && enableRoiDrawing) {
              // If within 5 pixels, replace the new coordinate with the first one
              const newX = firstCoordinate.x;
              const newY = firstCoordinate.y;
              setRoiOrTripwireCoordinates((prevCoordinates) => [...prevCoordinates, { x: newX, y: newY }]);
              setIsRoiLoopCompleted(true);
            } else if (enableRoiDrawing || (enableTripwireDrawing && roiOrTripwireCoordinates.length <= 3)) {
              setRoiOrTripwireCoordinates((prevCoordinates) => [...prevCoordinates, { x, y }]);
            }
            else if (enableTripwireDrawing && roiOrTripwireCoordinates.length === 4) {
              setEnableArrowDrawing(true);
              setArrowCoordinates((prevCoordinates) => [...prevCoordinates, { x, y }]);
            }
          } else {
            setRoiOrTripwireCoordinates((prevCoordinates) => [...prevCoordinates, { x, y }]);
          }
        }
        else if (enableArrowDrawing && arrowCoordinates.length <= 1) {
          setArrowCoordinates((prevCoordinates) => [...prevCoordinates, { x, y }]);
        }
      }
    };
    if (overlay)
      overlay.addEventListener('click', handleClick);
    return () => {
      if (overlay)
        overlay.removeEventListener('click', handleClick);
    };
  }, [enableArrowDrawing, enableRoiDrawing, enableTripwireDrawing, roiOrTripwireCoordinates, arrowCoordinates]);

  useEffect(() => {
    if (overlayRef.current) {
      const ctx = overlayRef.current.getContext('2d');
      ctx.clearRect(0, 0, overlayRef.current.width, overlayRef.current.height);
      ctx.strokeStyle = "#39FF14";
      ctx.lineWidth = 3.5;

      const drawDot = (x, y) => {
        ctx.beginPath();
        ctx.arc(x, y, 5, 0, 2 * Math.PI);
        ctx.fillStyle = "red";
        ctx.fill();
      };

      if (roiOrTripwireCoordinates.length > 0) {
        roiOrTripwireCoordinates.forEach(coordinate => {
          drawDot(coordinate.x, coordinate.y);
        });
      }

      if (arrowCoordinates.length > 0) {
        arrowCoordinates.forEach(coordinate => {
          drawDot(coordinate.x, coordinate.y);
        });
      }

      if (roiOrTripwireCoordinates.length > 1) {
        ctx.beginPath();
        ctx.moveTo(roiOrTripwireCoordinates[0].x, roiOrTripwireCoordinates[0].y);
        for (let i = 1; i < roiOrTripwireCoordinates.length; i += 1) {
          ctx.lineTo(roiOrTripwireCoordinates[i].x, roiOrTripwireCoordinates[i].y);
        }
        ctx.stroke();
      }

      if (arrowCoordinates.length > 1) {
        ctx.beginPath();
        ctx.moveTo(arrowCoordinates[0].x, arrowCoordinates[0].y);
        for (let i = 1; i < arrowCoordinates.length; i += 1) {
          ctx.lineTo(arrowCoordinates[i].x, arrowCoordinates[i].y);
        }
        const start = arrowCoordinates[0];
        const end = arrowCoordinates[1];
        drawArrow(ctx, start.x, start.y, end.x, end.y);
      }
    }
  }, [roiOrTripwireCoordinates, arrowCoordinates]);

  useEffect(() => {
    const asyncStreamRestartCall = async () => {
      await stopWebrtcConnection();
      if (mmsRangeStartTime.current || mmsRangeEndTime.current) {
        playMmsRange.current = true;
      }
      if (nvStreamerRangeStartTime.current || nvStreamerRangeEndTime.current) {
        playNvStreamerRange.current = true;
      }
      startWebrtcConnection();
    };

    const getRecordingStatus = () => {
      axiosInstance
        .get(`${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/status`,{ headers: { "streamId": sensor.sensorId } })
        .then((response) => {
          if (response.data) {
            if (response.data.recordingStatus === 'alwaysOn'
              || response.data.recordingStatus === 'schedule'
              || response.data.recordingStatus === 'user') {
              setRecordingStatus(true);
            }
            else {
              setRecordingStatus(false);
            }
          }
        })
        .catch((error) => {
          console.error(error);
          setErrorMessage(error.response.data.error_message);
        });
    }

    const getRecordingStatusInInterval = () => {
      if (page === 'video-wall' || adaptorType === 'streamer') {
        return;
      }
      getRecordingStatus();
      recordingIntervalRef.current = setInterval(() => {
        getRecordingStatus();
      }, 5000);
    };

    if (!firstTimeRender.current) {
      firstTimeRender.current = true;
      getRecordingStatusInInterval();
      if (page === 'recorded') {
        fetchRecordTimelines();
      }
    } else {
      asyncStreamRestartCall();
    }

  }, [quality]);

  useEffect(() => {
    forEach(streamList, (obj) => {
      if (obj.host === sensor.host && Object.prototype.hasOwnProperty.call(obj, sensor.sensorId)) {
        setSensorStreamList(obj[sensor.sensorId]);
      }
    });
  }, [streamList, sensor]);

  useEffect(() => {
    handleVideoMetadata();
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
    setIsRoiLoopCompleted(false);
    setEnableArrowDrawing(false);
    setEnableTripwireDrawing(false);
    setEnableRoiDrawing(false);
  }, [sensorInRow])

  useEffect(() => {
    console.log('iceConnectionState', iceConnectionState);
    switch (iceConnectionState) {
      case 'connecting':
        clearTimeout(errorTimeoutRef.current);
        setLoading(true);
        break;
      case 'connected':
        monitorFps();
        clearTimeout(errorTimeoutRef.current);
        clearTimeout(pollRef.current);
        setLoading(false);
        webrtcStatsHelper();
        if (recordingTest) {
          startRecordedStreamTest();
        }
        break;
      case 'disconnected':
        setLoading(false);
        timeoutAndWaitForReconnection();
        break;
      case 'failed':
        setLoading(false);
        stopWebrtcConnection();
        break;
      default:
        console.log(iceConnectionState);
    }
  }, [iceConnectionState]);

  useEffect(() => {
    if (showAnalyticsUI) {
      refreshRoiAndTripwireDropdown();
    }
  }, [showAnalyticsUI])

  useEffect(() => {
    setVideoDimensions();
    if (recordingTest) {
      playMmsRange.current = true;
    }
    if (page !== 'recorded') {
      startWebrtcConnection();
    }
    return () => {
      clearInterval(recordingIntervalRef.current);
      clearInterval(fpsInterval.current);
      stopWebrtcConnection();
      clearInterval(timelineIntervalRef.current);
      clearInterval(pollRef.current);
      clearInterval(recordedStreamTest.current);
      clearInterval(statsRef.current);
      clearInterval(streamStatusRef.current);
      getIceCandidateCount.current = 0;
      if (videoRef.current) {
        try {
          videoRef.current.srcObject = null;
          videoRef.current.remove();
        } catch (error) {
          console.error(error);
        }
      }
    };
  }, []);

  const handleExpandGems = () => {
    setExpandGems((prev => !prev));
  }

  const handleOverlayOpacity = (event, newValue) => {
    setOverlayOpacity(newValue);
  }

  const refreshRoiAndTripwireDropdown = async () => {
    await setStreamBitrate();
    getRoiData();
    getTripwireData();
  }

  const handleEnableRoiDrawing = () => {
    setIsRoiLoopCompleted(false);
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
    setEnableArrowDrawing(false);
    setEnableTripwireDrawing(false);
    setEnableRoiDrawing(true);
  }

  const handleEnableTripwireDrawing = () => {
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
    setEnableArrowDrawing(false);
    setEnableRoiDrawing(false);
    setIsRoiLoopCompleted(false);
    setEnableTripwireDrawing(true);
  }

  const handleAnalyticsSubmission = () => {
    submitAnalytics();
    console.log("** submission of analytics done, continue **");
    setEnableRoiDrawing(false);
    setEnableTripwireDrawing(false);
    setEnableArrowDrawing(false);
    setIsHoveredRoi(false);
    setIsHoveredTripWire(false);
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
    handleAnalyticsPopup();
  }

  const handleCancelAnalytics = () => {
    setEnableRoiDrawing(false);
    setEnableTripwireDrawing(false);
    setEnableArrowDrawing(false);
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
  }

  const handleAnalyticsPopup = () => {
    setOpenAnalyticsPopup((prev) => !prev);
  }

  const handleRoiOrTripwireName = (event) => {
    if (enableTripwireDrawing) {
      console.log(event.target.value);
      setTripwireName(event.target.value);
    }
    else {
      setRoiName(event.target.value);
    }
  }

  const interpolateCoordinate = (x, y, oldWidth, oldHeight, newWidth, newHeight) => {
    console.log(`interpolating ${oldHeight}x${oldHeight} to ${newWidth}x${newHeight}`);
    const scaleX = newWidth / oldWidth;
    const scaleY = newHeight / oldHeight;

    // Adjust coordinates based on the scaling factors
    const newX = x * scaleX;
    const newY = y * scaleY;

    return { x: Math.ceil(newX), y: Math.ceil(newY) };
  }

  const getRoiData = () => {
    axiosInstance.get(`${emdatEndpoint.current}/api/v2/config/roi?sensorId=${sensor.name}`)
      .then((response) => {
        if (response.data && response.data.rois) {
          const roiData = response.data.rois;
          roiData.push({ name: "Select all", id: "select-all" });
          setRoiData(roiData);
          console.log("Emdat GET request response: ", response.data);
        }
        else {
          setRoiData([]);
        }
        if (response.status === 200) {
          console.log("Emdat GET request success: ", response.status);
        }
      })
      .catch((error) => {
        setRoiData([]);
        if (error && error.response && error.response.status !== 422) {
          console.error("Emdat GET request failed: ", error);
          setErrorMessage('Failed to get ROI, try again');
        }
        else if (error && error.response && error.response.status === 422) {
          // Commenting due to bug 4546602
          // setErrorMessage('No ROIs found');
        }
      })
  }

  const getTripwireData = () => {
    axiosInstance.get(`${emdatEndpoint.current}/api/v2/config/tripwire?sensorId=${sensor.name}`)
      .then((response) => {
        if (response.data && response.data.tripwires) {
          const tripwireData = response.data.tripwires;
          tripwireData.push({ name: "Select all", id: "select-all" });
          setTripwireData(tripwireData)
          console.log("Emdat GET request response: ", response.data);
        }
        else {
          setTripwireData([]);
        }
        if (response.status === 200) {
          console.log("Emdat GET request success: ", response.status);
        }
      })
      .catch((error) => {
        setTripwireData([]);
        if (error && error.response && error.response.status !== 422) {
          console.error("Emdat GET request failed: ", error);
          setErrorMessage('Failed to get Tripwire, try again');
        }
        else if (error && error.response && error.response.status === 422) {
          // Commenting due to bug 4546602
          // setErrorMessage('No tripwires found');
        }
      })
  }

  const submitAnalytics = async () => {
    if (roiOrTripwireCoordinates.length > 0 && enableRoiDrawing) {
      const coordinates = JSON.parse(JSON.stringify(roiOrTripwireCoordinates));
      for (let i = 0; i < coordinates.length; i += 1) {
        coordinates[i] = interpolateCoordinate(
          coordinates[i].x,
          coordinates[i].y,
          overlayRef.current.width,
          overlayRef.current.height,
          videoWidth,
          videoHeight
        )
      }
      const uuid = generateUUID();
      const json = {
        "deleteIfPresent": true,
        "rois": [
          {
            "id": uuid,
            "name": roiName,
            "coordinates": coordinates
          }
        ],
        "sensorId": sensor.name
      }
      console.log("analytics json: ", json);
      await axiosInstance.post(`${emdatEndpoint.current}/api/v2/config/roi`, json, { headers: { "User-Type": "Admin" } })
        .then((response) => {
          if (response.data) {
            console.log("Emdat POST request response: ", response.data);
          }
          if (response.status === 200) {
            console.log("Emdat POST request success: ", response.status);
          }
        })
        .catch((error) => {
          console.error("Emdat POST request failed: ", error);
          setErrorMessage('Failed to set ROI, try again');
        })
    }
    else if (roiOrTripwireCoordinates.length > 0 && arrowCoordinates.length > 1 && enableTripwireDrawing) {
      const coordinates = JSON.parse(JSON.stringify(roiOrTripwireCoordinates));
      for (let i = 0; i < coordinates.length; i += 1) {
        coordinates[i] = interpolateCoordinate(
          coordinates[i].x,
          coordinates[i].y,
          overlayRef.current.width,
          overlayRef.current.height,
          videoWidth,
          videoHeight
        )
      }

      const newArrowCoordinates = JSON.parse(JSON.stringify(arrowCoordinates));
      for (let i = 0; i < newArrowCoordinates.length; i += 1) {
        newArrowCoordinates[i] = interpolateCoordinate(
          newArrowCoordinates[i].x,
          newArrowCoordinates[i].y,
          overlayRef.current.width,
          overlayRef.current.height,
          videoWidth,
          videoHeight
        )
      }
      const uuid = generateUUID();
      const json = {
        "deleteIfPresent": true,
        "tripwires": [
          {
            "id": uuid,
            "name": tripwireName,
            "wire": coordinates,
            "direction": {
              "p1": {
                "x": Math.ceil(newArrowCoordinates[0].x),
                "y": Math.ceil(newArrowCoordinates[0].y)
              },
              "p2": {
                "x": Math.ceil(newArrowCoordinates[1].x),
                "y": Math.ceil(newArrowCoordinates[1].y)
              },
              // optional fields
              // "entry": {
              //   "name": "string"
              // },
              // "exit": {
              //   "name": "string"
              // }
            }
          }
        ],
        "sensorId": sensor.name
      }
      console.log("analytics json: ", json);
      await axiosInstance.post(`${emdatEndpoint.current}/api/v2/config/tripwire`, json, { headers: { "User-Type": "Admin" } })
        .then((response) => {
          if (response.data) {
            console.log("Emdat POST request response: ", response.data);
          }
          if (response.status === 200) {
            console.log("Emdat POST request success: ", response.status);
          }
        })
        .catch((error) => {
          console.error("Emdat POST request failed: ", error);
          setErrorMessage('Failed to set Tripwire, try again');
        })
    }
    refreshRoiAndTripwireDropdown();
  }

  const drawArrow = (ctx, fromX, fromY, toX, toY, forwardDistance = 3) => {
    const headLength = 20; // length of head in pixels
    const angle = Math.atan2(toY - fromY, toX - fromX);

    // Calculate new endpoint for the arrowhead
    const arrowheadX = toX + forwardDistance * Math.cos(angle);
    const arrowheadY = toY + forwardDistance * Math.sin(angle);

    ctx.strokeStyle = "#39FF14"; // Green color
    ctx.fillStyle = "#39FF14"; // Green color

    // Draw the main line
    ctx.beginPath();
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    ctx.stroke();

    // Draw arrowhead from the new endpoint
    ctx.beginPath();
    ctx.moveTo(arrowheadX, arrowheadY);
    ctx.lineTo(
      arrowheadX - headLength * Math.cos(angle - Math.PI / 6),
      arrowheadY - headLength * Math.sin(angle - Math.PI / 6)
    );
    ctx.lineTo(
      arrowheadX - headLength * Math.cos(angle + Math.PI / 6),
      arrowheadY - headLength * Math.sin(angle + Math.PI / 6)
    );
    ctx.lineTo(arrowheadX, arrowheadY);
    ctx.closePath();
    ctx.fill();
  }

  const handleRoiSelection = (val) => {
    const initial = arr => arr.slice(0, -1);
    if (val && val.length > 0) {
      for (let i = 0; i < val.length; i += 1) {
        if (val[i].id === "select-all") {
          const result = initial(roiData);
          setSelectedRoiData(result);
          return;
        }
      }
    }
    setSelectedRoiData(val)
  }

  const handleTripwireSelection = (val) => {
    const initial = arr => arr.slice(0, -1);
    if (val && val.length > 0) {
      for (let i = 0; i < val.length; i += 1) {
        if (val[i].id === "select-all") {
          const result = initial(tripwireData);
          setSelectedTripwireData(result);
          return;
        }
      }
    }
    setSelectedTripwireData(val)
  }

  const handleVideoMetadata = () => {
    const video = document.getElementsByClassName('player-wrapper');
    if (video && overlayRef.current) {
      const overlay = overlayRef.current;
      overlay.width = video[0].offsetWidth;
      overlay.height = video[0].offsetHeight;
    }
  };

  const monitorFps = () => {
    let fpsSum = 0;
    let fpsCount = 0;
    const incrementFps = (fps) => {
      fpsSum += fps;
      // eslint-disable-next-line no-plusplus
      fpsCount++;
    };
    fpsInterval.current = setInterval(() => {
      if (!peerConnection.current || !peerConnection.current.getStats) {
        incrementFps(0);
        return;
      }
      peerConnection.current
        .getStats(null)
        .then((stats) => {
          stats.forEach((report) => {
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
              if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
                const fps = report.framesPerSecond;
                console.log(`${sensor.name} fps: `, fps);
                incrementFps(fps);
              } else {
                incrementFps(0);
              }
            }
          });
        })
        .catch((error) => {
          console.error('Error getting stats:', error);
        });
    }, 1000);
    setTimeout(() => {
      clearInterval(fpsInterval.current);
      const averageFps = fpsCount > 0 ? fpsSum / fpsCount : 0;
      console.log(sensor.name, 'Average fps: ', averageFps);
      if (averageFps >= 20 && averageFps <= 35) {
        console.debug(`${sensor.name} average fps`, averageFps);
      }
    }, 60000);
  };
  useEffect(() => {
    if (useVideoCoordinates) {
      const video = videoRef.current;

      if (!video) {
        return;
      }

      // add event listener for mousemove
      // video.addEventListener('mousemove', (e) => {
      //   const rect = video.getBoundingClientRect();
      //   const x = e.clientX - rect.left;
      //   const y = e.clientY - rect.top;
      //   console.log(`Mouse coordinates on hover: (${x}, ${y})`);
      // });

      // add event listener for click
      video.addEventListener('click', (e) => {
        const rect = video.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        console.log(`Mouse coordinates on click: (${x}, ${y})`);
      });

      // cleanup function to remove event listeners
      // eslint-disable-next-line consistent-return
      return () => {
        // video.removeEventListener('mousemove');
        video.removeEventListener('click', () => { });
      };
    }
  }, []);

  const timeoutAndWaitForReconnection = () => {
    errorTimeoutRef.current = setTimeout(() => {
      stopWebrtcConnection();
    }, 5000);
  };

  const resetState = () => {
    if (peerConnection.current) {
      peerConnection.current.close();
      peerConnection.current = null;
    }
    clearInterval(statsRef.current);
    clearInterval(recordedStreamTest.current);
    peerId.current = null;
    setIceConnectionState(null);
    setMediaStream(null);
    earlyCandidates.current = [];
    candidateSet.current.clear();
    setPlayerState(VIDEO_STATUS.UNINITIALIZED);
    setLoading(false);
    playNvStreamerRange.current = false;
    playMmsRange.current = false;
  };

  const handleClickFullscreen = () => {
    // eslint-disable-next-line react/no-find-dom-node
    screenfull.request(findDOMNode(videoRef.current));
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const getBitrateInfo = (width, height) => {
    console.log("Get bitrates for", width, height);
    // Determine the resolution key based on width and height
    let resolutionKey = `resolution_${width}`;
    if (height) {
      resolutionKey = `resolution_${height}`;
    }

    // Check if the resolution key exists in the JSON data
    if (streamSettings.current && Object.prototype.hasOwnProperty.call(streamSettings.current, resolutionKey)) {
      const resolutionData = streamSettings.current[resolutionKey];
      console.log("Bitrate found: ", resolutionData);
      const startBitrate = resolutionData.bitrate_start;
      const minBitrate = Math.min(...resolutionData.bitrate_range);
      const maxBitrate = Math.max(...resolutionData.bitrate_range);
      return {
        startBitrate,
        minBitrate,
        maxBitrate
      };
    }
    console.error('Resolution not found in JSON data, using default values');
    return {
      startBitrate: 8000,
      minBitrate: 4000,
      maxBitrate: 10000
    }
  }

  const rewriteSdp = (sdp) => {
    const bitrateInfo = getBitrateInfo(videoWidthRef.current, videoHeightRef.current);
    console.log("Modifying SDP with bitrates: ", bitrateInfo);
    const sdpStringFind = 'a=fmtp:(.*) (.*)';
    let sdpStringReplace = null;
    sdpStringReplace = `a=fmtp:$1 $2;x-google-max-bitrate=${bitrateInfo.maxBitrate};x-google-min-bitrate=${bitrateInfo.minBitrate};x-google-start-bitrate=${bitrateInfo.startBitrate}`;
    let newSDP = sdp.sdp.toString();
    newSDP = newSDP.replace(new RegExp(sdpStringFind, 'g'), sdpStringReplace);
    sdp.sdp = newSDP;
    console.debug('using modified sdp: ', sdp);
    return sdp;
  };

  const checkForData = () => {
    fpsTracker.current = 0;
    statsRef.current = setInterval(() => {
      console.log('Checking for stats..... !!!');
      if (liveTest && fpsTracker.current >= 3) {
        console.log('Stopping test, fps is zero/not found', sensor.name);
        clearInterval(statsRef.current);
        stopWebrtcConnection();
        dispatch(
          appSliceActions.setRecordedTestFailed({
            status: true,
            reason: `Video data is not received for live stream for more than 15 seconds, peer ID: ${peerId.current ? peerId.current : 'peer ID not available'
              }`,
          }),
        );
      }
      if (recordingTest && fpsTracker.current >= 11) {
        console.log('Stopping test, fps is zero/not found', sensor.name);
        clearInterval(statsRef.current);
        stopWebrtcConnection();
        dispatch(
          appSliceActions.setRecordedTestFailed({
            status: true,
            reason: `Video data is not received for recorded stream for more than 55 seconds, peer ID: ${peerId.current ? peerId.current : 'peer ID not available'
              }`,
          }),
        );
      }
      try {
        if (!peerConnection.current) {
          console.log('peer connection not established yet');
          return;
        }
        peerConnection.current.getStats(null).then((stats) => {
          stats.forEach((report) => {
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
              if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
                if (report.framesPerSecond > 0) {
                  console.log(sensor.name, ' FPS is: ', report.framesPerSecond);
                  fpsTracker.current = 0;
                } else {
                  console.log(sensor.name, ' FPS is zero: ', fpsTracker.current);
                  fpsTracker.current += 1;
                }
              } else {
                console.log(sensor.name, ' FPS is not present: ', fpsTracker.current);
                fpsTracker.current += 1;
              }
            }
          });
        });
      } catch (error) {
        console.error('Webrtc stats error', error);
      }
    }, 5000);
  };

  const startRecordedStreamTest = () => {
    recordedStreamTest.current = setInterval(async () => {
      let randomOperation;
      if (operations.current.length > 2) {
        const index = Math.floor(Math.random() * operations.current.length);
        randomOperation = operations.current[index];
        operations.current.splice(index, 1);
      } else {
        randomOperation = operations.current[Math.floor(Math.random() * operations.current.length)];
      }
      console.log('available operations: ', operations.current);
      console.log('current operation: ', randomOperation);
      console.log('playbackType: ', playbackTypeRef.current);
      switch (randomOperation) {
        case 'seek+10':
          setRecordedTestOperation('seek+10');
          recordStreamTestFunctions.seekPlusTen();
          break;
        case 'seek-10':
          setRecordedTestOperation('seek-10');
          recordStreamTestFunctions.seekMinusTen();
          break;
        case '1x':
          setRecordedTestOperation('1x');
          recordStreamTestFunctions.fastforwardByNum(1);
          break;
        case '2x':
          setRecordedTestOperation('2x');
          recordStreamTestFunctions.fastforwardByNum(2);
          break;
        case '4x':
          setRecordedTestOperation('4x');
          recordStreamTestFunctions.fastforwardByNum(4);
          break;
        case '8x':
          setRecordedTestOperation('8x');
          recordStreamTestFunctions.fastforwardByNum(8);
          break;
        case '-1x':
          setRecordedTestOperation('-1x');
          recordStreamTestFunctions.rewindByNum(-1);
          break;
        case '-2x':
          setRecordedTestOperation('-2x');
          recordStreamTestFunctions.rewindByNum(-2);
          break;
        case '-4x':
          setRecordedTestOperation('-4x');
          recordStreamTestFunctions.rewindByNum(-4);
          break;
        case '-8x':
          setRecordedTestOperation('-8x');
          recordStreamTestFunctions.rewindByNum(-8);
          break;
        default:
          break;
      }
    }, 10000);
  };

  const handleStreamSwitch = async () => {
    if (playbackType === 'recorded') {
      const jsonData = {
        peerId: peerConnection.current.peerId.toString(),
        streamId: selectedSubStreamId,
      };
      await axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/live/stream/swap`, jsonData)
        .then((response) => {
          console.log('stream switch, recorded to live ?', response.data);
          setPlaybackType('live');
        })
        .catch((e) => {
          console.error('Stream switch error, recorded to live', e);
          setErrorMessage('Switch stream from recorded to live failed');
        });
    } else {
      const jsonData = {
        peerId: peerConnection.current.peerId.toString(),
        streamId: selectedSubStreamId,
        startTime: '1970-01-01T00:00:00.000Z',
      };
      await axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/swap`, jsonData)
        .then((response) => {
          console.log('stream switch, live to recorded ?', response.data);
          setPlaybackType('recorded');
        })
        .catch((e) => {
          console.error('Stream switch error, live to recorded', e);
          setErrorMessage('Switch stream from live to recorded failed');
        });
    }
  };

  const handleRecordedTimeSync = async (marginTime) => {
    if (playbackType === 'live') {
      await handleStreamSwitch();
    }
    setOpenSyncTimeDialog(false);
    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      mediaSessionId: mediaSessionId.current,
      action: 'seekForward',
      value: subSeconds(new Date(), Number(marginTime)).toISOString(),
    };
    const localTimeString = new Date(`${jsonData.seek_value}.000Z`).toLocaleString();
    console.debug('Seeking to(UTC): ', jsonData.seek_value);
    console.debug('Seeking to(local): ', localTimeString);
    setStartTimeString(localTimeString);
    const promise = axiosInstance(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, {
      method: 'post',
      data: jsonData,
    });
    promise.then((response) => {
      console.log('stream seek ?', response.data);
      setPlayerState(VIDEO_STATUS.PLAYING);
    });
    promise.catch((e) => {
      console.error('Stream seek error', e);
    });
  };

  const webrtcStatsHelper = () => {
    webrtcStatsRef.current = setInterval(() => {
      try {
        if (!peerConnection.current || !mediaStream) {
          console.log('Stop collecting stats');
          clearInterval(webrtcStatsRef.current);
          return;
        }
        peerConnection.current.getStats(null).then((stats) => {
          stats.forEach((report) => {
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
              if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
                if (report.framesPerSecond > 0) {
                  clearInterval(webrtcStatsRef.current);
                  frameErrorRef.current = 0;
                  console.info('Webrtc client is receiving frames');
                } else if (frameErrorRef.current > 3) { setErrorMessage('Peer connection is successful but VST UI is not receiving frames'); } else {
                  frameErrorRef.current += 1;
                }
              } else {
                console.log('no framesPerSecond field found');
                if (frameErrorRef.current > 3) { setErrorMessage('Peer connection is successful but VST UI is not receiving frames'); } else {
                  frameErrorRef.current += 1;
                }
              }
            }
          });
        });
      } catch (error) {
        console.error('Webrtc stats error', error);
      }
    }, 5000);
  };

  const fetchRecordTimelines = (flag = true) => {
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/timelines`,{ headers: { "streamId": sensor.sensorId } })
      .then((response) => {
        if (response.data) {
          originalTimelines.current = response.data;
          setTimelines(response.data);
          setTimelineGaps(getTimelineGaps(response.data));
          if (recordingTest && response.data != null && response.data.length > 0) {
            const randomObj = response.data[Math.floor(Math.random() * response.data.length)];
            const t1 = new Date(randomObj.startTime).getTime();
            const t2 = new Date(randomObj.endTime).getTime();
            const randomTs = Math.floor(Math.random() * (t2 - t1 + 1) + t1);
            console.log(t1, t2, randomTs);
            mmsRangeStartTime.current = new Date(randomTs).toISOString();
            console.log(randomObj);
            console.log('using random start time', mmsRangeStartTime.current);
          }
          if (flag) {
            setSelectedInterval([new Date(response.data[0].startTime)]);
          }
          if (page === 'recorded') {
            selectedIntervalRef.current = [new Date(response.data[0].startTime)];
            if (flag) startWebrtcConnection();
          }
        }
      })
      .catch((error) => {
        console.error('unable to fetch timelines', error);
        if (flag) stopWebrtcConnection();
        setErrorMessage(error.response.data.error_message);
      });
  };

  const getSensorClientList = () => {
    const apiUrl = page === 'recorded' || recordingTest ?
      "api/v1/replay/stream/status" : "api/v1/live/stream/status";
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/${apiUrl}`)
      .then((response) => {
        if (response.data) {
          const parsedData = [];
          forEach(response.data, (obj) => {
            if (obj.deviceId === sensor.sensorId) {
              parsedData.push(obj);
            }
          });
          setSensorClientList(parsedData);
        }
      })
      .catch((e) => {
        console.error('WEBRTC RECEIVER: getIceCandidate error', e);
      });
  };

  const addIceCandidate = (candidate) => {
    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      candidate,
    };
    const iceCandidateEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/iceCandidate`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/iceCandidate`;
    const promise = axiosInstance(iceCandidateEndpoint, {
      method: 'post',
      data: jsonData,
    });
    promise.then((response) => {
      console.log(chalk.cyan('Added ICE candidate ?'), response.data);
    });
    promise.catch((e) => {
      console.error(chalk.bgCyan('Add ICE candidate error'), e);
    });
  };

  const onReceiveCandidate = (response) => {
    const candidates = response.data;
    console.debug(`Received candidates from VMS: ${JSON.stringify(candidates)}`);
    if (candidates) {
      console.debug('WEBRTC RECEIVER: Creating RTCIceCandidate from each received candidate..');
      for (let i = 0; i < candidates.length; i += 1) {
        if (!candidateSet.current.has(JSON.stringify(candidates[i]))) {
          candidateSet.current.add(JSON.stringify(candidates[i]));
          const candidate = new RTCIceCandidate(candidates[i]);
          console.debug(`Adding ICE candidate - ${i} :${JSON.stringify(candidate)}`);
          peerConnection.current.addIceCandidate(
            candidate,
            () => {
              console.debug(`addIceCandidate OK - ${i}`);
            },
            (error) => {
              console.debug(`addIceCandidate error - ${i}`, error);
            },
          );
        }
      }
    }
  };

  const getIceCandidate = () => {
    console.debug('WEBRTC RECEIVER: calling api/getIceCandidate');
    const iceCandidateEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/iceCandidate?peerId=${peerConnection.current.peerId}`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/iceCandidate?peerId=${peerConnection.current.peerId}`;
    axiosInstance
      .get(iceCandidateEndpoint)
      .then(onReceiveCandidate)
      .catch((e) => {
        console.error('WEBRTC RECEIVER: getIceCandidate error', e);
      });
  };

  const setRemoteDescription = (sessionDescriptionAnswer) => {
    peerConnection.current
      .setRemoteDescription(new RTCSessionDescription(sessionDescriptionAnswer))
      .then(() => {
        earlyCandidates.current.forEach(addIceCandidate);
        console.log(`Called getIceCandidate ${getIceCandidateCount.current + 1} times`);
        getIceCandidate();
        getIceCandidateCount.current = 0;
        clearInterval(pollRef.current);
        pollRef.current = setInterval(() => {
          getIceCandidateCount.current += 1;
          console.log(`Called getIceCandidate ${getIceCandidateCount.current + 1} times`);
          if (getIceCandidateCount.current >= 4) {
            console.log('Stop calling getIceCandidate');
            getIceCandidateCount.current = 0;
            clearInterval(pollRef.current);
          }
          getIceCandidate();
        }, 500);
      })
      .catch((error) => {
        console.error('WEBRTC RECEIVER: onReceiveCall: ', error);
        stopWebrtcConnection();
        setErrorMessage('Unable to set remote description');
      });
  };

  const sendSessionDescriptionToVst = (sessionDescription) => {
    const sessionDescriptionPayload = {
      clientIpAddr: publicIpAddr,
      peerId: peerConnection.current.peerId.toString(),
      options: {
        quality,
        rtptransport: 'udp',
        timeout: 60,
      },
      streamId: subStreamIdRef.current,
      sessionDescription,
    };
    if (page === 'video-wall') {
      delete sessionDescriptionPayload.streamId;
      sessionDescriptionPayload.options.composite = {
        doComposite: true,
        streamIds: videoWallList,
        showSensorName: {
          enable: true,
          position: [10, 10],
        }
      };
    }
    if (adaptorType === 'streamer' && playNvStreamerRange.current) {
      sessionDescriptionPayload.startTime = nvStreamerRangeStartTime.current;
      sessionDescriptionPayload.endTime = nvStreamerRangeEndTime.current;
      playNvStreamerRange.current = false;
    }
    if (adaptorType === 'vst' && selectedIntervalRef.current.length > 0 && !playMmsRange.current) {
      sessionDescriptionPayload.startTime = '1970-01-01T00:00:00.000Z';
    }
    if ((adaptorType === 'mms' || adaptorType === 'vst') && playMmsRange.current) {
      sessionDescriptionPayload.startTime = mmsRangeStartTime.current;
      if (endTimeInMsNeeded || endTimeDateNeeded) {
        sessionDescriptionPayload.endTime = mmsRangeEndTime.current;
      }
      playMmsRange.current = false;
    }
    const overlaySettings = {
      objectId: overlayFilter,
      color: overlayColor,
      thickness: bboxThickness,
      debug: overlayDebug,
      needBbox: overlayBbox,
      needTripwire: overlayTripwire,
      needRoi: overlayRoi,
      opacity: overlayOpacity
    };
    sessionDescriptionPayload.options.overlay = overlaySettings;
    if (liveTest) {
      const arr = ['auto', 'high', 'medium', 'low', 'pass_through'];
      const randomQuality = arr[Math.floor(Math.random() * arr.length)];
      sessionDescriptionPayload.options.quality = randomQuality;
      console.log('using random quality', randomQuality);
    }
    if (recordingTest) {
      const arr = ['auto', 'high', 'medium', 'low'];
      const randomQuality = arr[Math.floor(Math.random() * arr.length)];
      sessionDescriptionPayload.options.quality = randomQuality;
      console.log('using random quality', randomQuality);
    }
    console.debug('WEBRTC RECEIVER: Payload of stream start: ', sessionDescriptionPayload);
    const playbackStartEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/stream/start`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/stream/start`;
    const promise = axiosInstance(playbackStartEndpoint, {
      method: 'post',
      data: sessionDescriptionPayload,
    });
    promise.then((response) => {
      const sessionDescriptionAnswer = response.data;
      console.debug('Received response of stream start: ', sessionDescriptionAnswer);
      console.debug('WEBRTC RECEIVER: Signaling state is ', peerConnection.current.signalingState);
      if (peerConnection.current.signalingState === 'have-local-offer') {
        console.debug('WEBRTC RECEIVER: OK signalingState');
      } else {
        console.debug('WEBRTC RECEIVER: unexpected signalingState');
      }
      setRemoteDescription(sessionDescriptionAnswer);
      mediaSessionId.current = sessionDescriptionAnswer.mediaSessionId;
    });
    promise.catch((error) => {
      console.error('WEBRTC RECEIVER: wertc error: ', error);
      if (liveTest || recordingTest) {
        dispatch(
          appSliceActions.setRecordedTestFailed({
            status: true,
            reason: `api/stream/start failed for ${liveTest ? 'live stream' : 'recorded stream'}, peer ID: ${peerId.current ? peerId.current : 'peer ID not available'
              }`,
          }),
        );
      }
      stopWebrtcConnection();
      setErrorMessage(error.response.data.error_message);
    });
  };

  const createOffer = () => {
    peerConnection.current
      .createOffer(OFFER_OPTIONS)
      .then((sessionDescription) => {
        sessionDescription = rewriteSdp(sessionDescription);
        console.debug('WEBRTC RECEIVER: session Description', sessionDescription);
        peerConnection.current.setLocalDescription(sessionDescription);
        return sessionDescription;
      })
      .then((sessionDescription) => {
        sendSessionDescriptionToVst(sessionDescription);
      })
      .catch((error) => {
        console.error('WEBRTC RECEIVER: Failed to create offer', error);
        stopWebrtcConnection();
        setErrorMessage(error);
      });
  };

  const onConnectionStateChange = () => {
    // FireFox does not support onConnectionStateChange event
    console.info('WEBRTC RECEIVER: connection state change: ', peerConnection.current.connectionState);
    if (peerConnection.current.connectionState === 'disconnected') {
      console.debug('WEBRTC RECEIVER: Lost peer connection...');
    }
  };

  const onSignalingStateChange = () => {
    console.info('WEBRTC RECEIVER: signaling state change: ', peerConnection.current.signalingState);
  };

  const onIceGatheringStateChange = () => {
    console.info('WEBRTC RECEIVER: gathering state change: ', peerConnection.current.iceGatheringState);
  };

  const onIceCandidateError = (e) => {
    console.debug('WEBRTC RECEIVER: onIceCandidateError: ', e);
    if (e.errorCode !== 701) {
      console.error(`ICE candidate error, ${e.errorText} error code ${e.errorCode} and url ${e.url}`);
    }
    if (e.errorCode === 701) {
      console.debug('error code is 701 that means DNS failed for ipv6, harmless error');
    }
  };

  const onIceConnectionStateChange = () => {
    setIceConnectionState(peerConnection.current.iceConnectionState);
  };

 
  const onTrack = (event) => {
    const [stream] = event.streams;
    console.log('onTrack callback');
    // Ensure the video element is available before accessing it
    if (videoRef.current) {
      setIsAudioTrackPresent(stream.getAudioTracks().length > 0);
      videoRef.current.srcObject = stream;
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.info("Autoplay successful");
          })
          .catch((error) => {
            console.error("Autoplay failed", error);
            // Ensure videoRef.current is still available after the promise
          if (videoRef.current) {
            videoRef.current.muted = true; // Set muted after ensuring videoRef is valid
            videoRef.current.play(); // Try to play again after muting
          } else {
            console.error("videoRef became null after promise");
          }
          });
      }
    }
    else {
      console.error('videoRef is null or undefined');
    }
    setMediaStream(true);
  };
  

  const onIceCandidate = (event) => {
    if (!event.candidate) {
      console.debug('received null candidate, that means its the last candidate');
      return;
    }
    if (event.candidate) {
      if (event.candidate.candidate.length === 0) {
        console.log(event.candidate);
        console.debug('Recevived empty string for candidate - client is firefox');
        return;
      }
      console.debug('received candidate inside onIceCandidate callback: ', event.candidate.candidate);
      // If a srflx candidate was found, notify that the STUN server works!
      if (event.candidate.type === 'srflx') {
        console.debug('WEBRTC RECEIVER: The STUN server is reachable for this candidate!');
        console.debug(`Public IP Address is: ${event.candidate.address}`);
      }
      // If a relay candidate was found, notify that the TURN server works!
      if (event.candidate.type === 'relay') {
        console.debug('WEBRTC RECEIVER: The TURN server is reachable for this candidate!');
      }
      if (peerConnection.current && peerConnection.current.currentRemoteDescription) {
        addIceCandidate(event.candidate);
      } else {
        earlyCandidates.current.push(event.candidate);
      }
    }
  };

  const createRTCPeerConnection = (iceServers) => {
    console.debug('WEBRTC RECEIVER: ICE Servers: ', iceServers);
    let isSuccess = true;
    try {
      const pc = new RTCPeerConnection({ iceServers }, PEER_CONNECTION_OPTIONS);
      pc.peerId = peerId.current;
      pc.onicecandidate = onIceCandidate;
      pc.ontrack = onTrack;
      pc.oniceconnectionstatechange = onIceConnectionStateChange;
      pc.onicecandidateerror = onIceCandidateError;
      pc.onicegatheringstatechange = onIceGatheringStateChange;
      pc.onsignalingstatechange = onSignalingStateChange;
      pc.onconnectionstatechange = onConnectionStateChange;
      peerConnection.current = pc;
      if (page === 'outbound-stats') {
        window.peerConnectionOutbound = pc;
        window.peerConnectionOutboundId = peerId.current.toString();
        window.peerConnectionOutboundHost = sensor.host;
      }
    } catch (error) {
      console.error('Failed to create RTC peer connection.', error);
      stopWebrtcConnection();
      setErrorMessage('Failed to create RTC peer connection.');
      resetState();
      isSuccess = false;
    }
    if (!isSuccess) {
      return;
    }
    createOffer();
  };

  const setVideoDimensions = async () => {
    await axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/live/streams`)
      .then(async (response) => {
        console.debug('sensor settings response: ', response.data);
        try {
          const { data } = response;
          data.forEach(element => {
            Object.values(element).forEach(streams => {
              streams.forEach(stream => {
                if (stream.isMain && stream.streamId === selectedSubStreamId) {
                  console.log("Main stream: ", stream.metadata)
                  const { framerate } = stream.metadata;
                  const resolution = stream.metadata.resolution.split('x');
                  const width = resolution[0];
                  const height = resolution[1];
                  console.log(`Found Width: ${width}, Height: ${height}, Framerate: ${framerate}`);
                  setVideoWidth(width || 1920);
                  setVideoHeight(height || 1080);
                  videoWidthRef.current = width || 1920;
                  videoHeightRef.current = height || 1080;
                  setVideoFramerate(framerate || 30);
                  console.log(`Using Width: ${width || 1920}, Height: ${height || 1080}, Framerate: ${framerate || 30}`);
                }
              });
            });
          });
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      })
      .catch((error) => {
        console.log("Failed to fetch sensor settings ", error);
      })
  }

  const setStreamBitrate = async () => {
    const settingsApi = page === 'recorded' ? `${window.location.protocol}//${sensor.host}/api/v1/replay/configuration` :
      `${window.location.protocol}//${sensor.host}/api/v1/live/configuration`
    await axiosInstance
      .get(settingsApi)
      .then((response) => {
        if (response.data) {
          try {
            streamSettings.current = response.data.webrtc_video_quality_tunning || null;
            console.log("Stream settings: ", streamSettings.current);
            emdatEndpoint.current = response.data.analyticServerAddress || "localhost";
            if (response.data.analyticServerAddress &&
              response.data.analyticServerAddress !== "localhost" &&
              response.data.analyticServerAddress !== "") {
              setShowAnalyticsUI(true);
              window.emdatEndpoint = emdatEndpoint.current;
            }
          } catch (error) {
            console.log(error);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(error.response.data.error_message);
      });
  };

  const startWebrtcConnection = async () => {
    clearInterval(streamStatusRef.current);
    streamStatusRef.current = setInterval(() => {
      getStreamStatus();
    }, 5000);
    if (page === 'recorded' && selectedIntervalRef.current.length === 0 && adaptorType === 'vst') {
      setErrorMessage('No record timelines present, retry after some time');
      return;
    }
    if (recordingTest || liveTest) {
      clearInterval(statsRef.current);
      checkForData();
    }
    setLoading(true);
    setPlayerState(VIDEO_STATUS.PLAYING);
    peerId.current = generateUUID();
    setPeerIdStateVariable(peerId.current);
    await setStreamBitrate();
    await setVideoDimensions();
    const iceServerEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/iceServers?peerId=${peerId.current}`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/iceServers?peerId=${peerId.current}`;
    axiosInstance
      .get(iceServerEndpoint)
      .then((response) => {
        console.log(response.data);
        createRTCPeerConnection(response.data.iceServers);
      })
      .catch((error) => {
        console.error(error);
        stopWebrtcConnection();
        setErrorMessage(error.response.data.error_message);
      });
  };

  const stopWebrtcConnection = async () => {
    if (peerConnection.current != null) {
      const jsonData = {
        peerId: peerConnection.current.peerId.toString(),
        mediaSessionId: mediaSessionId.current,
      };
      const stopStreamEndpoint = page === 'recorded' || recordingTest
        ? `${window.location.protocol}//${sensor.host}/api/v1/replay/stream/stop`
        : `${window.location.protocol}//${sensor.host}/api/v1/live/stream/stop`;
      console.debug('WEBRTC RECEIVER: calling api/stream/stop with ', jsonData);
      await axiosInstance
        .post(stopStreamEndpoint, jsonData)
        .then((response) => {
          console.log('stream stop ?', response.data);
        })
        .catch((e) => {
          console.error('WEBRTC RECEIVER: stream stop error', e);
          if (liveTest || recordingTest) {
            dispatch(
              appSliceActions.setRecordedTestFailed({
                status: true,
                reason: `api/stream/stop failed for ${liveTest ? 'live stream' : 'recorded stream'}, peer ID: ${peerId.current ? peerId.current : 'peer ID not available'
                  }`,
              }),
            );
          }
        });
      resetState();
    }
    clearInterval(streamStatusRef.current);
  };

  const handlePlayPause = () => {
    if (!mediaStream && !loading) {
      startWebrtcConnection();
    }
    if (!peerConnection.current) {
      return;
    }
    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      mediaSessionId: mediaSessionId.current,
    };
    const pauseEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/stream/pause`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/stream/pause`;
    const resumeEndpoint = page === 'recorded' || recordingTest
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/stream/resume`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/stream/resume`;
    if (playerSate === VIDEO_STATUS.PAUSED) {
      axiosInstance
        .post(resumeEndpoint, jsonData)
        .then((response) => {
          console.log('stream resume ?', response.data);
          setPlayerState(VIDEO_STATUS.PLAYING);
        })
        .catch((e) => {
          console.error('stream resume error', e);
        });
    } else {
      axiosInstance
        .post(pauseEndpoint, jsonData)
        .then((response) => {
          console.log('stream pause ?', response.data);
          setPlayerState(VIDEO_STATUS.PAUSED);
        })
        .catch((e) => {
          console.error('Stream pause error', e);
        });
    }
  };

  const handleSubStreamMenuClose = () => {
    setSubStreamAnchorEl(null);
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleSwitchStreamFailed = async () => {
    await stopWebrtcConnection(); // if any
    startWebrtcConnection();
  };

  const handleSubStream = (stream) => {
    if (playerSate === VIDEO_STATUS.PLAYING || playerSate === VIDEO_STATUS.PAUSED) {
      const jsonData = {
        peerid: peerConnection.current.peerId.toString(),
        streamId: stream.streamId,
        mediaSessionId: mediaSessionId.current,
      };
      const promise = axiosInstance(`${window.location.protocol}//${sensor.host}/api/v1/live/stream/swap`, {
        method: 'post',
        data: jsonData,
      });
      promise.then((response) => {
        console.log('stream switch ?', response.data);
        subStreamIdRef.current = stream.streamId;
        setSelectedSubStreamId(stream.streamId);
      });
      promise.catch((e) => {
        console.error('Stream switch error', e);
        if (e.response.data.error_code === 'VMSNotSupportedError') {
          subStreamIdRef.current = stream.streamId;
          setSelectedSubStreamId(stream.streamId);
          console.log('Switch stream failed, trying to re-start stream...');
          handleSwitchStreamFailed();
        }
      });
    }
  };

  useEffect(() => {
    console.log('PLAYBACK TYPE:', playbackType);
  }, [playbackType]);

  const handleQualityChange = async (quality) => {
    setQuality(quality);
  };

  const handleSubStreamMenuOpen = (e) => {
    setSubStreamAnchorEl(e.currentTarget);
  };

  const handleClientMenuOpen = (e) => {
    getSensorClientList();
    setClientAnchorEl(e.currentTarget);
  };

  const handleClientMenuClose = () => {
    setClientAnchorEl(null);
  };

  const handleQualityMenuOpen = (e) => {
    setQualityAnchorEl(e.currentTarget);
  };

  const handleQualityMenuClose = () => {
    setQualityAnchorEl(null);
  };

  const handleVolumeChange = (event, newValue) => {
    setVolumeLevel(newValue);
    if (videoRef.current) {
      if (newValue > 0) {
        document.getElementById(`video-${sensor.sensorId}`).muted = false;
      } else if (newValue < 0.01) {
        document.getElementById(`video-${sensor.sensorId}`).muted = true;
      }
      document.getElementById(`video-${sensor.sensorId}`).volume = newValue;
    }
  };

  const handleOverlayDebug = () => {
    setOverlayDebug(!overlayDebug);
  };

  const handleOverlayBbox = () => {
    setOverlayBbox(!overlayBbox);
  };

  const handleOverlayTripwire = () => {
    setOverlayTripwire(!overlayTripwire);
  };

  const handleOverlayRoi = () => {
    setOverlayRoi(!overlayRoi);
  };

  const onOverlayFilterChange = (e) => {
    const str = e.target.value;
    if (str.length < 1) {
      setOverlayFilter([]);
    } else {
      const values = str.split(',');
      setOverlayFilter(values);
    }
  };

  const timelineScrubberErrorHandler = ({ error }) => {
    if (error) {
      console.log('Selected timeline with gap !');
    }
    setTimelineScrubberError(error);
  };

  const onChangeCallback = (selectedInterval) => {
    console.log('selectedInterval', selectedInterval);
    setSelectedInterval(selectedInterval);
    if (
      selectedInterval.length > 0
      && (playerSate === VIDEO_STATUS.PLAYING || playerSate === VIDEO_STATUS.PAUSED)
      && iceConnectionState === 'connected'
    ) {
      if (lastSeekRef.current == null) {
        lastSeekRef.current = [new Date().getTime(), selectedInterval[0]];
      } else {
        const lastSeekCallTime = lastSeekRef.current[0];
        const lastSeekTime = lastSeekRef.current[1];
        const currentTime = new Date().getTime();
        lastSeekRef.current = [currentTime, selectedInterval[0]];
        if (selectedInterval[0].getTime() === lastSeekTime.getTime()
          && currentTime - lastSeekCallTime < 500) {
          console.log('Duplicate seek ! Not seeking.. !!');
          return;
        }
      }
      seekToCustomTime(selectedInterval);
    }
  };

  const seekToCustomTime = async (selectedInterval) => {
    if (playbackType === 'live') {
      await handleStreamSwitch();
    }
    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      mediaSessionId: mediaSessionId.current,
      action: 'seekForward',
      value: new Date(selectedInterval[0]).toISOString(),
    };
    setStartTimeString(new Date(`${jsonData.seek_value}.000Z`).toLocaleString());
    const promise = axiosInstance(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, {
      method: 'post',
      data: jsonData,
    });
    promise.then((response) => {
      console.log('stream seek ?', response.data);
      setPlayerState(VIDEO_STATUS.PLAYING);
    });
    promise.catch((e) => {
      console.error('Stream seek error', e);
    });
  };

  const handleSeek = async (type = 'forward') => {
    if (playbackType === 'live') {
      await handleStreamSwitch();
    }
    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      mediaSessionId: mediaSessionId.current,
    };

    if (type === 'forward') {
      jsonData.action = 'seekForward';
    } else {
      jsonData.action = 'seekBackward';
    }

    axiosInstance
      .post(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, jsonData)
      .then((response) => {
        console.log('+- 10 seek ?', response.data);
      })
      .catch((error) => {
        console.log('Seek error', error);
        setErrorMessage(error.response.data.error_message);
      });
  };

  const handleFastForwardAndRewind = async (type = 'fast-forward') => {
    if (playbackType === 'live') {
      await handleStreamSwitch();
    }
    let newSpeed;
    if (type === 'fast-forward') {
      // eslint-disable-next-line no-nested-ternary
      newSpeed = playbackSpeed >= 1 ? playbackSpeed * 2
        : playbackSpeed === -1 ? 1 : playbackSpeed / 2;
      if (newSpeed > 8) {
        return;
      }
    } else {
      // eslint-disable-next-line no-nested-ternary
      newSpeed = playbackSpeed <= -1 ? playbackSpeed * 2
        : playbackSpeed === 1 ? -1 : playbackSpeed / 2;
      if (newSpeed < -8) {
        return;
      }
    }

    const jsonData = {
      peerId: peerConnection.current.peerId.toString(),
      mediaSessionId: mediaSessionId.current,
      action: newSpeed >= 1 ? 'fastForward' : 'rewind',
      value: Math.abs(newSpeed),
    };
    axiosInstance
      .post(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, jsonData)
      .then((response) => {
        setPlaybackSpeed(newSpeed);
        console.log('FF/Rewind ?', response.data);
      })
      .catch((error) => {
        console.log('FF/Rewind error', error);
        setErrorMessage(error.response.data.error_message);
      });
  };

  const handleOverlayOpen = () => {
    setShowOverlaySettings(!showOverlaySettings);
  };

  const handleNvStreamerRangeDialogClose = () => {
    setOpenNvStreamerRangeDialog(false);
  };

  const handleNvStreamerRangeDialogOpen = () => {
    setOpenNvStreamerRangeDialog(true);
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/storage/file/metadata?streamId=${sensor.sensorId}`,{ headers: { "streamId": sensor.sensorId } })
      .then((response) => {
        if (response.data) {
          setMetaData(response.data);
        }
      })
      .catch((error) => {
        console.log('Failed to get metadata', error);
        setErrorMessage(error.response.data.error_message);
      });
  };

  const handleMmsRangeDialogClose = () => {
    setOpenMmsRangeDialog(false);
  };

  const handleMmsRangeDialogOpen = () => {
    setOpenMmsRangeDialog(true);
  };

  const handleOverlaySettingsClose = () => {
    isAnalyticsSettings.current = false;
    setTimeout(() => {
      setIsAnalyticsSettingsState(false);
    }, 250);
    console.log("Closed dialog");
    setShowOverlaySettings(false);
  };

  const handleNvStreamerRangeSubmit = async (hhStart, mmStart, ssStart, hhEnd, mmEnd, ssEnd) => {
    setOpenNvStreamerRangeDialog(false);
    await stopWebrtcConnection();
    nvStreamerRangeStartTime.current = `${hhStart}:${mmStart}:${ssStart}`;
    nvStreamerRangeEndTime.current = `${hhEnd}:${mmEnd}:${ssEnd}`;
    playNvStreamerRange.current = true;
    startWebrtcConnection();
  };

  const updateTimelines = () => {
    const tempTimelines = originalTimelines.current != null
      ? JSON.parse(JSON.stringify(originalTimelines.current)) : [];
    if (tempTimelines != null && tempTimelines.length > 0) {
      const s1 = startDate.getTime();
      const e1 = endDate.getTime();
      console.log(s1, e1);
      const newTimelines = [];
      for (let i = 0; i < tempTimelines.length; i += 1) {
        const s2 = new Date(tempTimelines[i].startTime).getTime();
        const e2 = new Date(tempTimelines[i].endTime).getTime();
        console.log(s2, e2);
        if ((e2 > s1 && e2 < e1) || (s2 > s1 && s2 < e1)) {
          newTimelines.push(tempTimelines[i]);
        }
        if (s1 >= s2 && e2 >= e1) {
          newTimelines.push(tempTimelines[i]);
        }
      }
      for (let i = 0; i < newTimelines.length; i += 1) {
        const s2 = new Date(newTimelines[i].startTime).getTime();
        const e2 = new Date(newTimelines[i].endTime).getTime();
        if (s2 < s1) {
          newTimelines[i].startTime = new Date(s1).toISOString();
        }
        if (e2 > e1) {
          newTimelines[i].endTime = new Date(e1).toISOString();
        }
      }
      setTimelines(newTimelines);
      setTimelineGaps(getTimelineGaps(newTimelines));
      if (page === 'recorded' && newTimelines.length > 0) {
        selectedIntervalRef.current = [new Date(newTimelines[0].startTime)];
      }
    }
  };

  const resetTimelines = async () => {
    const tempTimelines = originalTimelines.current != null
      ? JSON.parse(JSON.stringify(originalTimelines.current)) : [];
    setTimelines(tempTimelines);
    setTimelineGaps(getTimelineGaps(tempTimelines));
    if (page === 'recorded' && tempTimelines.length > 0) {
      selectedIntervalRef.current = [new Date(tempTimelines[0].startTime)];
    }
    await stopWebrtcConnection();
    startWebrtcConnection();
  };

  const handleMmsRangeSubmit = async () => {
    setOpenMmsRangeDialog(false);
    await stopWebrtcConnection();
    mmsRangeStartTime.current = moment(startDate).toISOString();
    mmsRangeEndTime.current = moment(endDate).toISOString();
    if (mmsRangeStartTime.current != null && mmsRangeEndTime.current != null) {
      updateTimelines();
    }
    playMmsRange.current = true;
    setPlaybackType('recorded');
    playbackTypeRef.current = 'recorded';
    startWebrtcConnection();
  };

  const handlePictureApi = () => {
    if (page !== 'recorded' && adaptorType !== 'streamer') {
      const ingressController = store('ingressController');
      console.log('ingressController', ingressController);
      let url = `${window.location.protocol}//${sensor.host}/api/v1/live/stream/${sensor.sensorId}/picture`;
      let proxy = window.location.pathname;
      if (proxy != null && proxy !== '/' && proxy.length > 0) {
        if (proxy[proxy.length - 1] === '/') {
          proxy = proxy.slice(0, -1);
        }
        url = url.replace('/api', `${proxy}/api`);
      }
      const newWindow = window.open(url, '_blank');
      // eslint-disable-next-line eqeqeq
      if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
        setErrorMessage('Please enable pop-up and try again');
      }
    } else {
      queryStreamAndGetPicture();
    }
  };

  const queryStreamAndGetPicture = () => {
    const queryEndpoint = adaptorType !== 'streamer'
      ? `${window.location.protocol}//${sensor.host
      }/api/v1/replay/stream/query?peerid=${peerConnection.current.peerId.toString()}&mediaSessionId=${mediaSessionId.current
      }&metadata=false`
      : `${window.location.protocol}//${sensor.host
      }/api/v1/live/stream/query?peerId=${peerConnection.current.peerId.toString()}&mediaSessionId=${mediaSessionId.current
      }&metadata=false`;
    axiosInstance
      .get(queryEndpoint)
      .then((response) => {
        // {
        //   "metadata" : null,
        //   "ts" : 1667304122569000
        // }
        console.log('stream query response: ', response.data);
        if (response.data.ts != null) {
          handleScreenShot(response.data.ts);
        } else {
          console.log('Invalid TS recevied in stream query');
          setErrorMessage('Invalid TS recevied in stream query');
        }
      })
      .catch((e) => {
        console.log('Failed to get query stream', e);
        setErrorMessage('Failed to get query stream');
      });
  };

  const handleShowAnalytics = () => {
    if (peerConnection.current) {
      const roiIdList = [];
      const tripwireIdList = [];
      console.log("selectedRoiData: ", selectedRoiData);
      console.log("selectedTripwireData: ", selectedTripwireData);
      for (let i = 0; i < selectedRoiData.length; i += 1) {
        roiIdList.push(selectedRoiData[i].id);
      }
      for (let i = 0; i < selectedTripwireData.length; i += 1) {
        tripwireIdList.push(selectedTripwireData[i].id);
      }
      const json = {
        peerId: peerConnection.current.peerId.toString(),
        framerate: videoFramerate,
        resolution: `${videoWidth}x${videoHeight}`,
        overlay: {
          tripwire: { showAll: tripwireIdList.length === tripwireData.length - 1, id: tripwireIdList },
          roi: { showAll: roiIdList.length === roiData.length - 1, id: roiIdList }
        }
      };
      axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/live/stream/settings`, json)
        .then((response) => {
          if (response.data) {
            console.log("live stream set settings response: ", response.data);
          }
        })
        .catch((error) => {
          console.log('Failed to set live stream setting', error);
          setErrorMessage(error.response.data.error_message);
        });
    }
  }

  const handleDeleteAnalytics = async () => {
    for (let i = 0; i < selectedRoiData.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      await axiosInstance
        .delete(`${emdatEndpoint.current}/api/v2/config/roi?sensorId=${sensor.name}&roiId=${selectedRoiData[i].id}`, { headers: { "User-Type": "Admin" } })
        .then((response) => {
          setSelectedRoiData(prevState => (
            // Update the state by filtering out the item with the specified ID
            prevState.filter(item => item.id !== selectedRoiData[i].id)
          ));
          if (response.data) {
            console.log("delete roi response: ", response.data);
          }
        })
        .catch((error) => {
          console.log('Failed to delete ROI', error);
          setErrorMessage(error.response.data.error_message);
        });
    }

    for (let i = 0; i < selectedTripwireData.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      await axiosInstance
        .delete(`${emdatEndpoint.current}/api/v2/config/tripwire?sensorId=${sensor.name}&tripwireId=${selectedTripwireData[i].id}`, { headers: { "User-Type": "Admin" } })
        .then((response) => {
          console.log(selectedRoiData)
          setSelectedTripwireData(prevState => (
            // Update the state by filtering out the item with the specified ID
            prevState.filter(item => item.id !== selectedTripwireData[i].id)
          ));
          if (response.data) {
            console.log("delete Tripwire response: ", response.data);
          }
        })
        .catch((error) => {
          console.log('Failed to delete tripwire', error);
          setErrorMessage(error.response.data.error_message);
        });
    }
    refreshRoiAndTripwireDropdown();
  }

  const handleScreenShot = (timestamp) => {
    let utcDateTime = '';
    if (adaptorType === 'streamer') {
      utcDateTime = timestamp;
    } else {
      const ts = timestamp.toString().length === 16 ? timestamp / 1000 : timestamp;
      utcDateTime = moment(ts).toISOString();
    }
    const ingressController = store('ingressController');
    console.log('ingressController', ingressController);
    let url = adaptorType !== 'streamer'
      ? `${window.location.protocol}//${sensor.host}/api/v1/replay/stream/${sensor.sensorId}/picture?startTime=${utcDateTime}`
      : `${window.location.protocol}//${sensor.host}/api/v1/live/stream/${sensor.sensorId}/picture?startTime=${utcDateTime}`;
    let proxy = window.location.pathname;
    if (proxy != null && proxy !== '/' && proxy.length > 0) {
      if (proxy[proxy.length - 1] === '/') {
        proxy = proxy.slice(0, -1);
      }
      url = url.replace('/api', `${proxy}/api`);
    }
    const newWindow = window.open(url, '_blank');
    // eslint-disable-next-line eqeqeq
    if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
      setErrorMessage('Please enable pop-up and try again');
    }
  };

  const getStreamStatus = () => {
    if (peerConnection.current) {
      const streamStatusEndpoint = page === 'recorded' || recordingTest
        ? `${window.location.protocol}//${sensor.host
        }/api/v1/replay/stream/status?peerId=${peerConnection.current.peerId.toString()}&mediaSessionId=${mediaSessionId.current
        }`
        : `${window.location.protocol}//${sensor.host
        }/api/v1/live/stream/status?peerId=${peerConnection.current.peerId.toString()}&mediaSessionId=${mediaSessionId.current
        }`;
      axiosInstance
        .get(streamStatusEndpoint)
        .then((response) => {
          if (response.data.state) {
            switch (response.data.state) {
              case 'PLAYING':
                setStreamStatus(' is playing');
                break;
              case 'PAUSED':
                setStreamStatus(' is paused');
                break;
              case 'NOT_PLAYING':
                setStreamStatus(' is not playing');
                break;
              default:
                setStreamStatus(`status is ${response.data.state}`);
                break;
            }
          }
        })
        .catch((error) => {
          console.log('Failed to get stream status', error);
        });
    }
  };

  const onInfoClick = () => {
    if (adaptorType === 'streamer') {
      axiosInstance
        .get(`${window.location.protocol}//${sensor.host}/api/v1/storage/file/metadata?streamId=${sensor.sensorId}`,{ headers: { "streamId": sensor.sensorId } })
        .then((response) => {
          if (response.data) {
            setMetaData(response.data);
          }
        })
        .catch((error) => {
          console.log('Failed to get metadata', error);
          setErrorMessage(error.response.data.error_message);
        });
    }
    setOpenDrawer(true);
  };

  const handleSyncTimeClose = () => {
    setOpenSyncTimeDialog(false);
  };

  const handleAnalyticsSettings = () => {
    if (peerConnection.current) {
      const roiIdList = [];
      const tripwireIdList = [];
      for (let i = 0; i < selectedRoiData.length; i += 1) {
        roiIdList.push(selectedRoiData[i].id);
      }
      for (let i = 0; i < selectedTripwireData.length; i += 1) {
        tripwireIdList.push(selectedTripwireData[i].id);
      }
      const json = {
        peerId: peerConnection.current.peerId.toString(),
        framerate: videoFramerate,
        resolution: `${videoWidth}x${videoHeight}`,
        overlay: {
          bbox: { showAll: overlayBbox, objectId: overlayFilter },
          tripwire: { showAll: overlayTripwire, id: tripwireIdList },
          roi: { showAll: overlayRoi, id: roiIdList },
          color: overlayColor,
          thickness: bboxThickness,
          debug: overlayDebug,
          opacity: overlayOpacity
        }
      };
      axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/live/stream/settings`, json)
        .then((response) => {
          if (response.data) {
            console.log("live stream set settings response: ", response.data);
          }
        })
        .catch((error) => {
          console.log('Failed to set live stream setting', error);
          setErrorMessage(error.response.data.error_message);
        });
    }
  }

  const handleOverlaySubmit = async () => {
    if (isAnalyticsSettings.current) {
      isAnalyticsSettings.current = false;
      setIsAnalyticsSettingsState(false);
      setShowOverlaySettings(false);
      handleAnalyticsSettings();
      return;
    }
    setShowOverlaySettings(false);
    await stopWebrtcConnection();
    if ((adaptorType === 'mms' || adaptorType === 'vst') && (mmsRangeStartTime.current || mmsRangeEndTime.current)) {
      playMmsRange.current = true;
    }
    startWebrtcConnection();
  };

  const handleReplay = async () => {
    if (isStopping) {
      console.log("Already in the process of stopping, do nothing.")
      return;
    }
    isStopping = true;
    try {
      await stopWebrtcConnection();

      if ((adaptorType === 'mms' || adaptorType === 'vst') && (mmsRangeStartTime.current || mmsRangeEndTime.current)) {
        playMmsRange.current = true;
      }

      if (adaptorType === 'streamer' && (nvStreamerRangeStartTime.current || nvStreamerRangeEndTime.current)) {
        playNvStreamerRange.current = true;
      }

      startWebrtcConnection();
    } finally {
      isStopping = false;
    }
  };

  const debouncedHandleReplay = debounce(handleReplay, 1000);

  const debouncedHandleResetTimelines = debounce(resetTimelines, 1000);

  const handleSyncTimeOpen = () => {
    setOpenSyncTimeDialog(true);
  };

  const handleRoiInputValue = (val) => {
    setRoiInputValue(val);
  };

  const handleTripwireInputValue = (val) => {
    setTripwireInputValue(val);
  };

  const handleVideoClose = () => {
    closeSensor(sensor);
  };

  const onStartDateChange = (date) => {
    setStartDate(date.toDate());
    setStartTimeString(date.toDate());
  };

  const onEndTimeInMsChange = (e) => {
    if (startDate) {
      setEndDate(new Date(startDate.getTime() + Number(e.target.value)));
    }
  };

  const onEndTimeDateChange = (date) => {
    setEndDate(date.toDate());
  };

  const showVideoControls = () => {
    if (!(enableArrowDrawing || enableRoiDrawing || enableTripwireDrawing))
      setVideoControlsVisible(true);
  };

  const hideVideoControls = () => {
    setVideoControlsVisible(false);
  };

  const handleMouseOverForRoi = () => {
    setIsHoveredRoi(true);
    setTooltipTextForRoi(toolTipHelperTextForRoi);
  };

  const handleMouseOutForRoi = () => {
    setIsHoveredRoi(false);
    setTooltipTextForRoi('');
  };

  const handleMouseOverForTripWire = () => {
    setIsHoveredTripWire(true);
    setTooltipTextForTripWire(toolTipHelperTextForTripwire);
  };

  const handleMouseOutForTripWire = () => {
    setIsHoveredTripWire(false);
    setTooltipTextForTripWire('');
  };

  const drawerInfo = [
    {
      name: 'peer ID',
      value: peerIdStateVariable,
    },
    {
      name: 'device ID',
      value: sensor.sensorId,
    },
    {
      name: 'device IP',
      value: sensor.sensorIp,
    },
  ];
  if (adaptorType !== 'streamer' && page === 'recorded') {
    drawerInfo.push({
      name: 'start time',
      value: startTimeString ? startTimeString.toLocaleString() : '',
    });
    drawerInfo.push({
      name: 'end time',
      value: endDate ? endDate.toLocaleString() : '',
    });
  }
  if (adaptorType === 'streamer' && metaData) {
    if (Object.prototype.hasOwnProperty.call(metaData, 'Bitrate')) {
      drawerInfo.push({
        name: 'birate',
        value: metaData.Bitrate,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Codec')) {
      drawerInfo.push({
        name: 'codec',
        value: metaData.Codec,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Container')) {
      drawerInfo.push({
        name: 'container',
        value: metaData.Container,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Duration')) {
      drawerInfo.push({
        name: 'duration',
        value: metaData.Duration,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Framerate')) {
      drawerInfo.push({
        name: 'framerate',
        value: metaData.Framerate,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Height')) {
      drawerInfo.push({
        name: 'height',
        value: metaData.Height,
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Scan type')) {
      drawerInfo.push({
        name: 'scan type',
        value: metaData['Scan type'],
      });
    }
    if (Object.prototype.hasOwnProperty.call(metaData, 'Width')) {
      drawerInfo.push({
        name: 'width',
        value: metaData.Width,
      });
    }
  }

  if (onlyVideo) {
    return (
      <div className="player-wrapper">
        <video
          controls
          width="100%"
          height="100%"
          autoPlay
          muted
          style={{ background: 'black', objectFit: 'contain' }}
          className="react-player"
          ref={(e) => {
            videoRef.current = e;
          }}
          id={`video-only-${sensor.sensorId}`}
        />
        {errorMessage && (
          <Stack className="react-player-error" direction="row" alignItems="center">
            <Typography sx={{ color: 'error.main', pl: 2 }} variant="overline">
              {errorMessage}
            </Typography>
            <IconButton
              onClick={() => {
                setErrorMessage(null);
              }}
              edge="end"
              sx={{ color: 'white', marginLeft: 'auto', pr: 2 }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        )}
      </div>
    );
  }

  const handleRightClickOnCanvas = (e) => {
    e.preventDefault();
    setRoiOrTripwireCoordinates([]);
    setArrowCoordinates([]);
    if (enableArrowDrawing) {
      setEnableArrowDrawing(false);
      setEnableTripwireDrawing(true);
    }
  }

  const recordStreamTestFunctions = (() => {
    const seekPlusTen = async () => {
      handleSeek('forward');
    };
    const seekMinusTen = async () => {
      handleSeek('backward');
    };
    const fastforwardByNum = async (num) => {
      const jsonData = {
        peerId: peerConnection.current.peerId.toString(),
        mediaSessionId: mediaSessionId.current,
        action: 'fastForward',
        value: Math.abs(num),
      };
      axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, jsonData)
        .then((response) => {
          setPlaybackSpeed(num);
          console.log('FF ?', response.data);
        })
        .catch((error) => {
          console.log('FF', error);
          setErrorMessage(error.response.data.error_message);
        });
    };
    const rewindByNum = async (num) => {
      const jsonData = {
        peerId: peerConnection.current.peerId.toString(),
        mediaSessionId: mediaSessionId.current,
        action: 'rewind',
        value: Math.abs(num),
      };
      axiosInstance
        .post(`${window.location.protocol}//${sensor.host}/api/v1/replay/stream/seek`, jsonData)
        .then((response) => {
          setPlaybackSpeed(num);
          console.log('Rewind ?', response.data);
        })
        .catch((error) => {
          console.log('Rewind error', error);
          setErrorMessage(error.response.data.error_message);
        });
    };
    return {
      seekPlusTen: () => seekPlusTen,
      seekMinusTen: () => seekMinusTen,
      fastforwardByNum: (n) => fastforwardByNum(n),
      rewindByNum: (n) => rewindByNum(n),
    };
  })();

  return (
    <>
      <Dialog open={openAnalyticsPopup} onClose={handleAnalyticsPopup}>
        <DialogTitle>Analytics</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Enter ${enableRoiDrawing ? 'ROI name' : 'Tripwire name to continue'}`}
          </DialogContentText>
          <TextField
            label="Enter name"
            variant="outlined"
            fullWidth
            value={enableRoiDrawing ? roiName : tripwireName}
            onChange={handleRoiOrTripwireName}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleAnalyticsSubmission}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Card>
        {recordingTest && <p>{recordedTestOperation}</p>}
        <Accordion sx={{ mb: 1 }} expanded={expandGems}>
          <AccordionSummary
            id="panel-header"
            sx={{
              minHeight: 40,
              '& .MuiAccordionSummary-content': {
                margin: '0',
                cursor: 'default'
              }
            }}
          >
            {
              showAnalyticsUI && !isStreamer &&
              <Typography sx={{ p: 1 }} variant="h6">Analytics</Typography>
            }
            <Box sx={{ flexGrow: 1 }} />
            {
              showAnalyticsUI && !isStreamer && 
              <IconButton onClick={handleExpandGems}>
                <ExpandMoreIcon />
              </IconButton>
            }
            {
              showAnalyticsUI && !isStreamer &&
              <Tooltip title={analyticsRefreshHelperText}>
                <IconButton size="small" onClick={refreshRoiAndTripwireDropdown}>
                  <SyncIcon />
                </IconButton>
              </Tooltip>
            }
            <IconButton onClick={handleVideoClose}>
              <CloseIcon />
            </IconButton>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container alignContent="center" alignItems="center">
              <Grid item xs={12}>
                <Divider sx={{ mb: 1 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Manage ROIs and Tripwires
                  </Typography>
                </Divider>
              </Grid>
            </Grid>
            <Grid container spacing={2} alignContent="center" alignItems="center" justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Item>
                  <MultiSelector
                    id="roi-selector"
                    placeholder="Type to search"
                    label={`Select ROIs`}
                    value={selectedRoiData}
                    inputValue={roiInputValue}
                    onInputChange={handleRoiInputValue}
                    onChange={handleRoiSelection}
                    getOptionLabel={(option) => {
                      if (option.name) {
                        return `${option.name}`;
                      }
                      return "NA";

                    }}
                    options={roiData}
                  />
                </Item>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Item>
                  <MultiSelector
                    id="tripwire-selector"
                    placeholder="Type to search"
                    label={`Select Tripwires`}
                    value={selectedTripwireData}
                    inputValue={tripwireInputValue}
                    onInputChange={handleTripwireInputValue}
                    onChange={handleTripwireSelection}
                    getOptionLabel={(option) => {
                      if (option.name) {
                        return `${option.name}`;
                      }
                      return "NA";

                    }}
                    options={tripwireData}
                  />
                </Item>
              </Grid>
              <Grid container spacing={1} alignItems="flex-start" justifyContent="flex-start">
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <Item>
                    <Tooltip title={toolTipHelperShowRoiTripwire}>
                      <Button sx={{ width: '97px' }} size="small" variant="contained" onClick={handleShowAnalytics} startIcon={<VisibilityIcon />}>
                        Show
                      </Button>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} >
                  <Item>
                    <Tooltip title={analyticsSettingsHelperText}>
                      <Button sx={{ width: '97px' }} size="small" variant="contained" onClick={() => { isAnalyticsSettings.current = true; setIsAnalyticsSettingsState(true); handleOverlayOpen() }} startIcon={<SettingsIcon />}>
                        Settings
                      </Button>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} >
                  <Item>
                    <Tooltip title={toolTipHelperDeleteRoiTripwire}>
                      <Button sx={{ width: '97px' }} size="small" variant="contained" color="error" onClick={handleDeleteAnalytics} startIcon={<DeleteIcon />}>
                        Delete
                      </Button>
                    </Tooltip>
                  </Item>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="flex-start" justifyContent="flex-start">
                <Grid item xs={12} >
                  <Item>
                    <Divider flexItem >
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        Add ROIs and Tripwires
                      </Typography>
                    </Divider>
                  </Item>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="flex-start" justifyContent="flex-start">
                <Grid item xs={4} sm={4} md={4} lg={4} >
                  <Item>
                    {!enableRoiDrawing && (
                      <Tooltip title={tooltipTextForRoi} placement="top">
                        <div className={isHoveredRoi ? 'blurred' : ''}>
                        <Button
                          sx={{ width: '97px' }}
                          variant="contained"
                          color={!enableRoiDrawing ? "primary" : "secondary"}
                          onClick={handleEnableRoiDrawing}
                          onMouseOver={handleMouseOverForRoi}
                          onMouseOut={handleMouseOutForRoi}
                          disabled={enableTripwireDrawing}
                          startIcon={<BrushIcon />}
                          size="small"
                        >
                          ROI
                        </Button>
                        {isHoveredRoi && (
                          <div className="video-container">
                            <video autoPlay loop muted className="hover-video">
                              <source src={`${process.env.PUBLIC_URL}/assets/videos/roi-illustration.mp4`} type="video/mp4" />
                                  Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                        </div>
                      </Tooltip>
                    )}

                    {enableRoiDrawing && (
                      <Button sx={{ width: '97px' }} size="small" variant="contained" onClick={handleCancelAnalytics} color="error" startIcon={<CancelIcon />}>
                        Cancel
                      </Button>
                    )}
                  </Item>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} >
                  <Item>
                    {!enableArrowDrawing && !enableTripwireDrawing && (
                      <Tooltip title={tooltipTextForTripWire} placement="top">
                        <div className={isHoveredTripWire ? 'blurred' : ''}>
                        <Button
                          sx={{ width: '97px' }}
                          size="small"
                          variant="contained"
                          color={!enableTripwireDrawing ? "primary" : "secondary"}
                          onClick={handleEnableTripwireDrawing}
                          onMouseOver={handleMouseOverForTripWire}
                          onMouseOut={handleMouseOutForTripWire}
                          disabled={enableRoiDrawing}
                          startIcon={<EditIcon />}
                        >
                          Tripwire
                        </Button>
                        {isHoveredTripWire && (
                          <div className="video-container">
                          <video autoPlay loop muted className="hover-video">
                            <source src={`${process.env.PUBLIC_URL}/assets/videos/tripwire.mp4`} type="video/mp4" />
                                Your browser does not support the video tag.
                          </video>
                        </div>
                      )}
                        </div>
                      </Tooltip>
                    )}

                    {(enableArrowDrawing || enableTripwireDrawing) && (
                      <Button size="small" sx={{ width: '97px' }} variant="contained" onClick={handleCancelAnalytics} color="error" startIcon={<CancelIcon />}>
                        Cancel
                      </Button>
                    )}
                  </Item>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} >
                  <Item>
                    <Button
                      sx={{ width: '97px' }}
                      size="small"
                      variant="contained"
                      onClick={handleAnalyticsPopup}
                      color="success"
                      disabled={!enableArrowDrawing && !enableRoiDrawing && !enableTripwireDrawing}
                      endIcon={<SendIcon />}
                    >
                      Done
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {
          showAnalyticsUI &&
          <Grid container>
            <Grid item xs={12}>
              <Divider sx={{ mb: 1, mt: () => { if (expandGems) { return -2; } return; }, ml: 1.5, mr: 1.5 }}>
                {
                  expandGems &&
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Video player
                  </Typography>
                }

              </Divider>
            </Grid>
          </Grid>
        }
        <Card sx={{ boxShadow: 'none' }}>
          <CardHeader
            sx={{
              m: () => {
                if (showAnalyticsUI) return 1;
                return;
              }, p: () => {
                if (showAnalyticsUI) return 1;
                return;
              }
            }}
            title={(
              <Box>
                {sensorInRow > 2 && (
                  <Box
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'inline',
                      },
                    }}
                  >
                    <Marquee speed={40} gradientWidth={50} pauseOnHover>
                      <Typography variant="h6" className="video-title">
                        <b>
                          {sensor.name}
                          {streamStatus}
                        </b>
                      </Typography>
                    </Marquee>
                  </Box>
                )}
                {sensorInRow <= 2 && (
                  <Typography
                    variant={`${showAnalyticsUI ? "h6" : "h4"}`}
                    className="video-title"
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'inline',
                      },
                    }}
                  >
                    <b>
                      {sensor.name}
                      {streamStatus}
                    </b>
                  </Typography>
                )}
                <Box
                  sx={{
                    display: {
                      xs: 'inline',
                      sm: 'inline',
                      md: 'inline',
                      lg: 'none',
                    },
                  }}
                >
                  <Marquee speed={40} gradientWidth={50} pauseOnHover>
                    <Typography variant="h6" className="video-title">
                      <b>
                        {sensor.name}
                        {streamStatus}
                      </b>
                    </Typography>
                  </Marquee>
                </Box>
              </Box>
            )}
            subheader={<Typography variant="caption">
              {sensor.remoteDeviceName && sensor.remoteDeviceLocation ?
                `at ${sensor.remoteDeviceName} (${sensor.remoteDeviceLocation})` : ""}
            </Typography>} />
          <div className="player-wrapper" onMouseEnter={showVideoControls} onMouseLeave={hideVideoControls}>
            {loading && (
              <div className="video-overlay">
                <Iconify color="white" width={70} icon="eos-icons:bubble-loading" />
              </div>
            )}
            <video
              width="100%"
              height="100%"
              autoPlay
              muted
              style={{ background: 'black', objectFit: 'contain' }}
              className="react-player"
              ref={(e) => {
                videoRef.current = e;
              }}
              id={`video-${sensor.sensorId}`}
              onLoadedMetadata={handleVideoMetadata} />
            <canvas
              onContextMenu={handleRightClickOnCanvas}
              ref={overlayRef}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1
              }} />
            {!errorMessage && videoControlsVisible && (
              <Tooltip title="Info" placement="top">
                <IconButton className="react-player-info" onClick={onInfoClick} sx={{ color: 'white', zIndex: 3 }}>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )}
            {recordingStatus && (
              <IconButton className="react-player-rec" sx={{ cursor: 'default' }}>
                <FiberManualRecordIcon sx={{ color: 'error.main' }} />
              </IconButton>
            )}
            {errorMessage && (
              <Stack className="react-player-error" direction="row" alignItems="center" sx={{ zIndex: 2 }}>
                <Typography sx={{ color: 'error.main', pl: 2 }} variant="overline">
                  {errorMessage}
                </Typography>
                <IconButton
                  onClick={() => {
                    setErrorMessage(null);
                  }}
                  edge="end"
                  sx={{ color: 'white', marginLeft: 'auto', pr: 2 }}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            )}
            {videoControlsVisible && (
              <Stack spacing={2} direction="row" justifyContent="space-between" className="react-player-controls" sx={{ zIndex: 2 }}>
                <Stack direction="row" justifyContent="center">
                  <Tooltip title="Play-Pause" placement="top">
                    <IconButton id="play-pause-btn" onClick={handlePlayPause} edge="end" sx={{ color: 'white' }}>
                      {playerSate !== VIDEO_STATUS.PLAYING ? <PlayCircleIcon /> : <PauseCircleIcon />}
                    </IconButton>
                  </Tooltip>
                  {page === 'recorded' && playbackType === 'recorded' && (
                    <>
                      <Tooltip title="Rewind" placement="top">
                        <IconButton
                          id="rewind-btn"
                          onClick={() => {
                            handleFastForwardAndRewind('rewind');
                          }}
                          edge="end"
                          sx={{ color: 'white' }}
                        >
                          <Badge badgeContent={playbackSpeed} invisible={playbackSpeed >= 0}>
                            <FastRewindIcon />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Fast-Forward" placement="top">
                        <IconButton
                          id="fast-forward-btn"
                          onClick={() => {
                            handleFastForwardAndRewind('fast-forward');
                          }}
                          edge="end"
                          sx={{ color: 'white' }}
                        >
                          <Badge badgeContent={playbackSpeed} invisible={playbackSpeed <= 1}>
                            <FastForwardIcon />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                      {!isDesktop
                        || (sensorInRow <= 2 && (
                          <>
                            <Tooltip title="Seek -10" placement="top">
                              <IconButton
                                id="seek-10-backward"
                                onClick={() => {
                                  handleSeek('backward');
                                }}
                                edge="end"
                                sx={{ color: 'white' }}
                              >
                                <Replay10Icon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Seek +10" placement="top">
                              <IconButton
                                id="seek-10-forward"
                                onClick={() => {
                                  handleSeek('forward');
                                }}
                                edge="end"
                                sx={{ color: 'white' }}
                              >
                                <Forward10Icon />
                              </IconButton>
                            </Tooltip>
                          </>
                        ))}
                    </>
                  )}
                  <Box
                    sx={{
                      width: {
                        xs: 100,
                        sm: 100,
                        md: sensorInRow === 4 ? 100 : 130,
                      },
                    }}
                  >
                    <Stack direction="row" alignItems="center">
                      <IconButton
                        onClick={() => setVolumeLevel((prev) => (prev === 0 ? 1 : 0))}
                        edge="end"
                        sx={{ mr: 1, color: 'white' }}
                        disabled={!isAudioTrackPresent}
                      >
                        {volumeLevel === 0 ? (
                          <VolumeOffIcon sx={{ color: 'white' }} disabled={!isAudioTrackPresent} />
                        ) : (
                          <VolumeUp sx={{ color: 'white' }} disabled={!isAudioTrackPresent} />
                        )}
                      </IconButton>
                      <Slider
                        value={volumeLevel}
                        onChange={handleVolumeChange}
                        step={0.1}
                        min={0}
                        max={1}
                        disabled={!isAudioTrackPresent}
                        sx={{ color: 'white' }} />
                    </Stack>
                  </Box>
                </Stack>
                <Stack direction="row" justifyContent="center" sx={{ pr: 2 }}>
                  {page !== 'recorded' && (
                    <Tooltip title="Streams" placement="top">
                      <IconButton onClick={handleSubStreamMenuOpen} edge="end" sx={{ color: 'white' }}>
                        <ViewStreamIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {(page === 'recorded' || adaptorType === 'streamer') && playbackType === 'recorded' && (
                    <Tooltip title="Replay" placement="top">
                      <IconButton onClick={debouncedHandleReplay} edge="end" sx={{ color: 'white' }}>
                        <ReplayIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {page === 'recorded' && adaptorType !== 'streamer' && playbackType === 'recorded' && (
                    <Tooltip title="Sync to current time" placement="top">
                      <IconButton onClick={handleSyncTimeOpen} edge="end" sx={{ color: 'white' }}>
                        <UpdateIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {(page === 'recorded' || page === 'live' || adaptorType === 'streamer') && (
                    <Tooltip title="Overlay" placement="top">
                      <IconButton onClick={handleOverlayOpen} edge="end" sx={{ color: 'white' }}>
                        {showOverlaySettings && <WidgetsOutlinedIcon />}
                        {!showOverlaySettings && <WidgetsIcon />}
                      </IconButton>
                    </Tooltip>
                  )}

                  <Menu
                    anchorEl={subStreamAnchorEl}
                    open={Boolean(subStreamAnchorEl)}
                    onClose={handleSubStreamMenuClose}
                    TransitionComponent={Fade}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    {sensorStreamList.map(
                      (subStream, index) => subStream.metadata
                        && subStream.metadata.resolution !== '' && (
                          <MenuItem
                            onClick={() => {
                              handleSubStream(subStream);
                            }}
                            key={(subStream.metadata?.resolution ?? 'NA') + subStream.name + index}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: subStream.streamId === selectedSubStreamId ? 'bold' : 'normal',
                              }}
                            >
                              {subStream.metadata?.resolution === '' || !subStream.metadata?.resolution
                                ? 'NA'
                                : subStream.metadata.resolution}
                            </Typography>
                          </MenuItem>
                        )
                    )}
                  </Menu>

                  {sensorInRow < 3 && (
                    <Box sx={{ display: { xs: 'none', sm: 'none', md: 'inline' } }}>
                      <Tooltip title="Clients" placement="top">
                        <IconButton onClick={handleClientMenuOpen} edge="end" sx={{ color: 'white' }}>
                          <GroupIcon />
                        </IconButton>
                      </Tooltip>

                      <Menu
                        anchorEl={clientAnchorEl}
                        open={Boolean(clientAnchorEl)}
                        onClose={handleClientMenuClose}
                        TransitionComponent={Fade}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                        transformOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                      >
                        {sensorClientList.map((client, index) => (
                          <MenuItem onClick={() => { }} key={client.deviceId + index}>
                            {client.clientIpAddress}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Box>
                  )}

                  <Tooltip title="Take screenshot" placement="top">
                    <IconButton onClick={handlePictureApi} edge="end" sx={{ color: 'white' }}>
                      <SensorAltIcon />
                    </IconButton>
                  </Tooltip>

                  {adaptorType === 'streamer' && (
                    <Tooltip title="Select range" placement="top">
                      <IconButton onClick={handleNvStreamerRangeDialogOpen} edge="end" sx={{ color: 'white' }}>
                        <DateRangeIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  {page === 'recorded' && (
                    <Tooltip title="Select range" placement="top">
                      <IconButton onClick={handleMmsRangeDialogOpen} edge="end" sx={{ color: 'white' }}>
                        <DateRangeIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  {!isDesktop
                    || (sensorInRow <= 2 && (
                      <Tooltip title="Quality" placement="top">
                        <IconButton onClick={handleQualityMenuOpen} edge="end" sx={{ color: 'white' }}>
                          <VideoSettingsIcon />
                        </IconButton>
                      </Tooltip>
                    ))}

                  <Menu
                    anchorEl={qualityAnchorEl}
                    open={Boolean(qualityAnchorEl)}
                    onClose={handleQualityMenuClose}
                    TransitionComponent={Fade}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        handleQualityChange('auto');
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: quality === 'auto' ? 'bold' : 'normal' }}>
                        Auto
                      </Typography>
                    </MenuItem>
                    {!(adaptorType === 'vst' && page === 'recorded') && adaptorType !== 'mms' && (
                      <MenuItem
                        onClick={() => {
                          handleQualityChange('pass_through');
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: quality === 'pass_through' ? 'bold' : 'normal',
                          }}
                        >
                          Pass-through
                        </Typography>
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        handleQualityChange('high');
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: quality === 'high' ? 'bold' : 'normal' }}>
                        High
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleQualityChange('medium');
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: quality === 'medium' ? 'bold' : 'normal',
                        }}
                      >
                        Medium
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      dense
                      onClick={() => {
                        handleQualityChange('low');
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: quality === 'low' ? 'bold' : 'normal' }}>
                        Low
                      </Typography>
                    </MenuItem>
                  </Menu>
                  <IconButton onClick={handleClickFullscreen} edge="end" sx={{ color: 'white' }}>
                    <FullscreenIcon />
                  </IconButton>
                </Stack>
              </Stack>
            )}
            <Dialog open={openSyncTimeDialog} onClose={handleSyncTimeClose}>
              <DialogTitle>Delay playback</DialogTitle>
              <DialogContent>
                <Box sx={{ p: 3 }}>
                  <Typography variant="body2" gutterBottom>
                    Delay playback by:
                    {' '}
                  </Typography>
                  <TextField defaultValue={0} size="small" name="time" label="time(seconds)" inputRef={syncTimeRef} />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="error" onClick={handleSyncTimeClose}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleRecordedTimeSync(syncTimeRef.current.value);
                  }}
                  autoFocus
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openMmsRangeDialog} onClose={handleMmsRangeDialogClose}>
              <DialogTitle>Select start and end time</DialogTitle>
              <DialogContent>
                <Box sx={{ p: 1 }}>
                  <Typography>{'Start time: '}</Typography>
                  <DatePicker
                    className="mms-range-picker"
                    showTime={{ format: 'HH:mm:ss.SSS' }}
                    format="YYYY-MM-DD HH:mm:ss.SSS"
                    onOk={onStartDateChange}
                    popupStyle={{ zIndex: 999999 }}
                    showNow={false} />
                  <Stack direction="row" alignContent="center">
                    <Box>
                      <input
                        type="checkbox"
                        checked={endTimeInMsNeeded}
                        onChange={() => {
                          if (!endTimeDateNeeded) setEndTimeInMsNeeded(!endTimeInMsNeeded);
                        }} />
                    </Box>
                    <Typography gutterBottom>{'Duration required ? '}</Typography>
                  </Stack>

                  {endTimeInMsNeeded && (
                    <TextField
                      defaultValue={0}
                      size="small"
                      name="duration"
                      label="Duration(in milli-seconds)"
                      onChange={onEndTimeInMsChange} />
                  )}
                  <Stack direction="row" alignContent="center">
                    <Box>
                      <input
                        type="checkbox"
                        checked={endTimeDateNeeded}
                        onChange={() => {
                          if (!endTimeInMsNeeded) setEndTimeDateNeeded(!endTimeDateNeeded);
                        }} />
                    </Box>
                    <Typography gutterBottom>{'End date-time required ? '}</Typography>
                  </Stack>

                  {endTimeDateNeeded && (
                    <DatePicker
                      className="mms-range-picker"
                      showTime={{ format: 'HH:mm:ss.SSS' }}
                      format="YYYY-MM-DD HH:mm:ss.SSS"
                      onOk={onEndTimeDateChange}
                      popupStyle={{ zIndex: 999999 }}
                      showNow={false} />
                  )}
                </Box>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="error" onClick={handleMmsRangeDialogClose}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleMmsRangeSubmit} autoFocus>
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openNvStreamerRangeDialog} onClose={handleNvStreamerRangeDialogClose}>
              <DialogTitle>Select start and end time</DialogTitle>
              <DialogContent>
                {metaData && (
                  <Typography>
                    Duration of
                    {' '}
                    {sensor.name}
                    {' '}
                    is
                    {' '}
                    <b>
                      {metaData.Duration}
                      {' '}
                      seconds
                    </b>
                  </Typography>
                )}
                <Box sx={{ p: 3 }}>
                  <Typography variant="overline">Start time:</Typography>
                  <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
                    <TextField defaultValue={0} size="small" name="hh" label="hh" inputRef={hhStartRef} />
                    <TextField defaultValue={0} size="small" name="mm" label="mm" inputRef={mmStartRef} />
                    <TextField defaultValue={0} size="small" name="ss" label="ss" inputRef={ssStartRef} />
                  </Stack>
                  <Typography variant="overline">End time:</Typography>
                  <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
                    <TextField defaultValue={0} size="small" name="hh" label="hh" inputRef={hhEndRef} />
                    <TextField defaultValue={0} size="small" name="mm" label="mm" inputRef={mmEndRef} />
                    <TextField defaultValue={0} size="small" name="ss" label="ss" inputRef={ssEndRef} />
                  </Stack>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="error" onClick={handleNvStreamerRangeDialogClose}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleNvStreamerRangeSubmit(
                      hhStartRef.current.value,
                      mmStartRef.current.value,
                      ssStartRef.current.value,
                      hhEndRef.current.value,
                      mmEndRef.current.value,
                      ssEndRef.current.value
                    );
                  }}
                  autoFocus
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={showOverlaySettings} onClose={handleOverlaySettingsClose}>
              <DialogTitle>Select overlay settings</DialogTitle>
              <DialogContent>
                <Box sx={{ p: 3 }}>
                  <Box sx={{ display: 'inline' }}>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                      <Typography variant="body2" style={{ minWidth: '130px' }}>Overlay color: </Typography>
                      <div id="colorPicker">
                        <div
                          id="red"
                          onClick={() => setOverlayColor('red')}
                          style={{
                            top: overlayColor === 'red' ? '-2px' : '',
                          }} />
                        <div
                          id="green"
                          onClick={() => setOverlayColor('green')}
                          style={{
                            top: overlayColor === 'green' ? '-2px' : '',
                          }} />
                        <div
                          id="blue"
                          onClick={() => setOverlayColor('blue')}
                          style={{
                            top: overlayColor === 'blue' ? '-2px' : '',
                          }} />
                        <div
                          id="black"
                          onClick={() => setOverlayColor('black')}
                          style={{
                            top: overlayColor === 'black' ? '-2px' : '',
                          }} />
                        <div
                          id="white"
                          onClick={() => setOverlayColor('white')}
                          style={{
                            top: overlayColor === 'white' ? '-2px' : '',
                          }} />
                        <div
                          id="yellow"
                          onClick={() => setOverlayColor('yellow')}
                          style={{
                            top: overlayColor === 'yellow' ? '-2px' : '',
                          }} />
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px', marginTop: 10 }}>
                      <Typography variant="body2" style={{ minWidth: '130px' }}>Object IDs: </Typography>
                      <input
                        type="text"
                        id="overlayFilter"
                        placeholder="overlay-filter"
                        value={overlayFilter}
                        onChange={onOverlayFilterChange}
                        style={{ width: '50px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                      <Typography variant="body2" style={{ minWidth: '130px' }}>Bbox:</Typography>
                      <Switch checked={overlayBbox} onChange={handleOverlayBbox} />
                    </div>
                    {
                      !isAnalyticsSettingsState &&
                      <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                        <Typography variant="body2" style={{ minWidth: '130px' }}>ROI:</Typography>
                        <Switch checked={overlayRoi} onChange={handleOverlayRoi} />
                      </div>
                    }
                    {
                      !isAnalyticsSettingsState &&
                      <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                        <Typography variant="body2" style={{ minWidth: '130px' }}>Tripwire:</Typography>
                        <Switch checked={overlayTripwire} onChange={handleOverlayTripwire} />
                      </div>
                    }

                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                      <Typography variant="body2" style={{ minWidth: '130px' }}>Opacity: <b>{overlayOpacity}</b></Typography>
                      <Slider
                        aria-label="Transparency"
                        value={overlayOpacity}
                        onChange={handleOverlayOpacity}
                        valueLabelDisplay="auto"
                        step={1}
                        marks
                        min={0}
                        max={255}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                      <Typography variant="body2">
                        Bbox Thickness:{' '}
                        <b>{bboxThickness}</b>
                      </Typography>
                      <br />
                    </div>
                    <div style={{ display: 'flex', maxHeight: '5rem', overflowY: 'scroll' }}>
                      <LineWidthPicker
                        selLine={bboxThickness}
                        onWidthSelect={(v) => {
                          setBboxThickness(v);
                        }}
                         />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                      <Typography variant="body2" style={{ minWidth: '130px' }}>Overlay Debug:</Typography>
                      <Switch checked={overlayDebug} onChange={handleOverlayDebug} />
                    </div>
                  </Box>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="error" onClick={handleOverlaySettingsClose}>
                  Close
                </Button>
                <Button variant="contained" onClick={handleOverlaySubmit} autoFocus>
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          {(timelines == null || timelines.length === 0) && page === 'recorded' && (
            <Box
              className="scrubber-container"
              sx={{
                pt: 5, pb: 8, pl: 6, pr: 6, zIndex: 10, position: 'relative',
              }}
            >
              <Box sx={{ position: 'absolute', right: 0, top: 20 }}>
                <Tooltip title="Reset timelines" placement="top">
                  <IconButton onClick={debouncedHandleResetTimelines}>
                    <RestartAltIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          )}
          {timelines != null && timelines.length > 0 && (
            <Box
              className="scrubber-container"
              sx={{
                pt: 5, pb: 8, pl: 6, pr: 6, zIndex: 10, position: 'relative',
              }}
            >
              <Box sx={{ position: 'absolute', right: 0, top: 20 }}>
                <Tooltip title="Reset timelines" placement="top">
                  <IconButton onClick={debouncedHandleResetTimelines}>
                    <RestartAltIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <TimeRange
                error={timelineScrubberError}
                ticksNumber={isDesktop && sensorInRow === 1 ? 10 : 3}
                selectedInterval={selectedInterval}
                timelineInterval={[new Date(timelines[0].startTime),
                new Date(timelines[timelines.length - 1].endTime)]}
                onUpdateCallback={timelineScrubberErrorHandler}
                onChangeCallback={onChangeCallback}
                containerClassName="scrubber-container"
                disabledIntervals={timelineGaps}
                step={1}
                tooltipTag="Time:"
                formatTick={(ms) => format(new Date(ms), 'MM/dd HH:mm:ss')}
                formatTooltip={(ms) => format(new Date(ms), 'HH:mm:ss.SSS')} />
            </Box>
          )}
        </Card>
        <SensorInfoDrawer
          open={openDrawer}
          onClose={onCloseDrawer}
          info={drawerInfo}
          peerConnection={peerConnection} />
      </Card>
    </>
  );
}

VideoPlayer.propTypes = {
  sensor: PropTypes.shape({
    firmwareVersion: PropTypes.string.isRequired,
    hardware: PropTypes.string.isRequired,
    hardwareId: PropTypes.string.isRequired,
    sensorId: PropTypes.string.isRequired,
    sensorIp: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    manufacturer: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    remoteDeviceName: PropTypes.string.isRequired,
    remoteDeviceLocation: PropTypes.string.isRequired,
    position: PropTypes.shape({
      depth: PropTypes.string.isRequired,
      direction: PropTypes.string.isRequired,
      fieldOfView: PropTypes.string.isRequired,
      gps: PropTypes.shape({
        latitude: PropTypes.string.isRequired,
        longitude: PropTypes.string.isRequired,
      }),
    }),
    serialNumber: PropTypes.string.isRequired,
    host: PropTypes.string.isRequired,
  }).isRequired,
  sensorInRow: PropTypes.number,
  isStreamer: PropTypes.bool.isRequired,
  page: PropTypes.string,
  onlyVideo: PropTypes.bool,
  closeSensor: PropTypes.func,
  recordingTest: PropTypes.bool,
  liveTest: PropTypes.bool,
  useVideoCoordinates: PropTypes.bool,
  videoWallList: PropTypes.array,
};

VideoPlayer.defaultProps = {
  sensorInRow: 2,
  onlyVideo: false,
  recordingTest: false,
  liveTest: false,
  useVideoCoordinates: false,
  videoWallList: [],
};
